"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: miimosa/loans/v1/dashboard.proto
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionsExportResponse = exports.TransactionsExportRequest = exports.TxVoucher = exports.TxTax = exports.TxTransferRefundEvent = exports.TxTransferEvent = exports.TxSponsorTransferEvent = exports.TxRepayTransferRegularEvent = exports.TxBaseEvent = exports.Transaction = exports.TransactionsResponse = exports.TransactionsRequest = exports.LenderLoanSummaryResponse = exports.RepayTerm = exports.LenderLoanSummaryRequest = exports.LendingNote_File = exports.LendingNote = exports.LendingNotesResponse = exports.LendingNotesRequest = exports.ExtractLenderLoanSummariesXLSResponse = exports.ExtractLenderLoanSummariesXLSRequest = exports.LenderPortfolioSummaryResponse_InvestedAmountPerSectorEntry = exports.LenderPortfolioSummaryResponse = exports.LenderPortfolioSummaryRequest = exports.LenderLoanSummary = exports.LenderLoanSummariesResponse = exports.LenderLoanSummariesRequest = exports.AvailableRepayTermYearsResponse = exports.AvailableRepayTermYearsRequest = exports.RepayTermSummariesResponse = exports.RepayTermSummary = exports.RepayTermSummariesRequest = exports.FinancialStatementResponse = exports.FinancialStatementRequest = exports.RequestAsUser = exports.transactionKindToJSON = exports.transactionKindFromJSON = exports.TransactionKind = exports.lenderLoanTerminatedStatusToJSON = exports.lenderLoanTerminatedStatusFromJSON = exports.LenderLoanTerminatedStatus = exports.lenderLoanProcessingStatusToJSON = exports.lenderLoanProcessingStatusFromJSON = exports.LenderLoanProcessingStatus = exports.lenderLoanSummaryPrimaryStatusToJSON = exports.lenderLoanSummaryPrimaryStatusFromJSON = exports.LenderLoanSummaryPrimaryStatus = exports.lenderLoanSummariesRequestStatusToJSON = exports.lenderLoanSummariesRequestStatusFromJSON = exports.LenderLoanSummariesRequestStatus = void 0;
exports.DashboardServiceClient = exports.RepayTermsExportEvent = exports.TransactionsExportEvent = exports.RefreshRecoverySummaryEvent = exports.RefreshLenderLoanSummariesEvent = exports.RepayTermsExportResponse = exports.RepayTermsExportRequest = void 0;
/* eslint-disable */
var collect_1 = require("../../common/v1/collect");
var health_1 = require("../../common/v1/health");
var month_1 = require("../../common/v1/month");
var pagination_1 = require("../../common/v1/pagination");
var product_kind_1 = require("../../common/v1/product_kind");
var recovery_status_1 = require("../../common/v1/recovery_status");
var repay_terms_1 = require("../../common/v1/repay_terms");
var term_frequency_1 = require("../../common/v1/term_frequency");
exports.LenderLoanSummariesRequestStatus = {
    LENDER_LOAN_SUMMARIES_REQUEST_STATUS_UNSPECIFIED: "LENDER_LOAN_SUMMARIES_REQUEST_STATUS_UNSPECIFIED",
    LENDER_LOAN_SUMMARIES_REQUEST_STATUS_WAITING_GENERATION: "LENDER_LOAN_SUMMARIES_REQUEST_STATUS_WAITING_GENERATION",
    /** @deprecated */
    LENDER_LOAN_SUMMARIES_REQUEST_STATUS_PROCESSING: "LENDER_LOAN_SUMMARIES_REQUEST_STATUS_PROCESSING",
    LENDER_LOAN_SUMMARIES_REQUEST_STATUS_LATE: "LENDER_LOAN_SUMMARIES_REQUEST_STATUS_LATE",
    LENDER_LOAN_SUMMARIES_REQUEST_STATUS_TERMINATED: "LENDER_LOAN_SUMMARIES_REQUEST_STATUS_TERMINATED",
    LENDER_LOAN_SUMMARIES_REQUEST_STATUS_OK: "LENDER_LOAN_SUMMARIES_REQUEST_STATUS_OK",
    UNRECOGNIZED: "UNRECOGNIZED",
};
function lenderLoanSummariesRequestStatusFromJSON(object) {
    switch (object) {
        case 0:
        case "LENDER_LOAN_SUMMARIES_REQUEST_STATUS_UNSPECIFIED":
            return exports.LenderLoanSummariesRequestStatus.LENDER_LOAN_SUMMARIES_REQUEST_STATUS_UNSPECIFIED;
        case 1:
        case "LENDER_LOAN_SUMMARIES_REQUEST_STATUS_WAITING_GENERATION":
            return exports.LenderLoanSummariesRequestStatus.LENDER_LOAN_SUMMARIES_REQUEST_STATUS_WAITING_GENERATION;
        case 2:
        case "LENDER_LOAN_SUMMARIES_REQUEST_STATUS_PROCESSING":
            return exports.LenderLoanSummariesRequestStatus.LENDER_LOAN_SUMMARIES_REQUEST_STATUS_PROCESSING;
        case 3:
        case "LENDER_LOAN_SUMMARIES_REQUEST_STATUS_LATE":
            return exports.LenderLoanSummariesRequestStatus.LENDER_LOAN_SUMMARIES_REQUEST_STATUS_LATE;
        case 4:
        case "LENDER_LOAN_SUMMARIES_REQUEST_STATUS_TERMINATED":
            return exports.LenderLoanSummariesRequestStatus.LENDER_LOAN_SUMMARIES_REQUEST_STATUS_TERMINATED;
        case 5:
        case "LENDER_LOAN_SUMMARIES_REQUEST_STATUS_OK":
            return exports.LenderLoanSummariesRequestStatus.LENDER_LOAN_SUMMARIES_REQUEST_STATUS_OK;
        case -1:
        case "UNRECOGNIZED":
        default:
            return exports.LenderLoanSummariesRequestStatus.UNRECOGNIZED;
    }
}
exports.lenderLoanSummariesRequestStatusFromJSON = lenderLoanSummariesRequestStatusFromJSON;
function lenderLoanSummariesRequestStatusToJSON(object) {
    switch (object) {
        case exports.LenderLoanSummariesRequestStatus.LENDER_LOAN_SUMMARIES_REQUEST_STATUS_UNSPECIFIED:
            return "LENDER_LOAN_SUMMARIES_REQUEST_STATUS_UNSPECIFIED";
        case exports.LenderLoanSummariesRequestStatus.LENDER_LOAN_SUMMARIES_REQUEST_STATUS_WAITING_GENERATION:
            return "LENDER_LOAN_SUMMARIES_REQUEST_STATUS_WAITING_GENERATION";
        case exports.LenderLoanSummariesRequestStatus.LENDER_LOAN_SUMMARIES_REQUEST_STATUS_PROCESSING:
            return "LENDER_LOAN_SUMMARIES_REQUEST_STATUS_PROCESSING";
        case exports.LenderLoanSummariesRequestStatus.LENDER_LOAN_SUMMARIES_REQUEST_STATUS_LATE:
            return "LENDER_LOAN_SUMMARIES_REQUEST_STATUS_LATE";
        case exports.LenderLoanSummariesRequestStatus.LENDER_LOAN_SUMMARIES_REQUEST_STATUS_TERMINATED:
            return "LENDER_LOAN_SUMMARIES_REQUEST_STATUS_TERMINATED";
        case exports.LenderLoanSummariesRequestStatus.LENDER_LOAN_SUMMARIES_REQUEST_STATUS_OK:
            return "LENDER_LOAN_SUMMARIES_REQUEST_STATUS_OK";
        case exports.LenderLoanSummariesRequestStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.lenderLoanSummariesRequestStatusToJSON = lenderLoanSummariesRequestStatusToJSON;
exports.LenderLoanSummaryPrimaryStatus = {
    LENDER_LOAN_SUMMARY_PRIMARY_STATUS_UNSPECIFIED: "LENDER_LOAN_SUMMARY_PRIMARY_STATUS_UNSPECIFIED",
    LENDER_LOAN_SUMMARY_PRIMARY_STATUS_WAITING_GENERATION: "LENDER_LOAN_SUMMARY_PRIMARY_STATUS_WAITING_GENERATION",
    LENDER_LOAN_SUMMARY_PRIMARY_STATUS_PROCESSING: "LENDER_LOAN_SUMMARY_PRIMARY_STATUS_PROCESSING",
    LENDER_LOAN_SUMMARY_PRIMARY_STATUS_TERMINATED: "LENDER_LOAN_SUMMARY_PRIMARY_STATUS_TERMINATED",
    UNRECOGNIZED: "UNRECOGNIZED",
};
function lenderLoanSummaryPrimaryStatusFromJSON(object) {
    switch (object) {
        case 0:
        case "LENDER_LOAN_SUMMARY_PRIMARY_STATUS_UNSPECIFIED":
            return exports.LenderLoanSummaryPrimaryStatus.LENDER_LOAN_SUMMARY_PRIMARY_STATUS_UNSPECIFIED;
        case 1:
        case "LENDER_LOAN_SUMMARY_PRIMARY_STATUS_WAITING_GENERATION":
            return exports.LenderLoanSummaryPrimaryStatus.LENDER_LOAN_SUMMARY_PRIMARY_STATUS_WAITING_GENERATION;
        case 2:
        case "LENDER_LOAN_SUMMARY_PRIMARY_STATUS_PROCESSING":
            return exports.LenderLoanSummaryPrimaryStatus.LENDER_LOAN_SUMMARY_PRIMARY_STATUS_PROCESSING;
        case 3:
        case "LENDER_LOAN_SUMMARY_PRIMARY_STATUS_TERMINATED":
            return exports.LenderLoanSummaryPrimaryStatus.LENDER_LOAN_SUMMARY_PRIMARY_STATUS_TERMINATED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return exports.LenderLoanSummaryPrimaryStatus.UNRECOGNIZED;
    }
}
exports.lenderLoanSummaryPrimaryStatusFromJSON = lenderLoanSummaryPrimaryStatusFromJSON;
function lenderLoanSummaryPrimaryStatusToJSON(object) {
    switch (object) {
        case exports.LenderLoanSummaryPrimaryStatus.LENDER_LOAN_SUMMARY_PRIMARY_STATUS_UNSPECIFIED:
            return "LENDER_LOAN_SUMMARY_PRIMARY_STATUS_UNSPECIFIED";
        case exports.LenderLoanSummaryPrimaryStatus.LENDER_LOAN_SUMMARY_PRIMARY_STATUS_WAITING_GENERATION:
            return "LENDER_LOAN_SUMMARY_PRIMARY_STATUS_WAITING_GENERATION";
        case exports.LenderLoanSummaryPrimaryStatus.LENDER_LOAN_SUMMARY_PRIMARY_STATUS_PROCESSING:
            return "LENDER_LOAN_SUMMARY_PRIMARY_STATUS_PROCESSING";
        case exports.LenderLoanSummaryPrimaryStatus.LENDER_LOAN_SUMMARY_PRIMARY_STATUS_TERMINATED:
            return "LENDER_LOAN_SUMMARY_PRIMARY_STATUS_TERMINATED";
        case exports.LenderLoanSummaryPrimaryStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.lenderLoanSummaryPrimaryStatusToJSON = lenderLoanSummaryPrimaryStatusToJSON;
exports.LenderLoanProcessingStatus = {
    LENDER_LOAN_PROCESSING_STATUS_UNSPECIFIED: "LENDER_LOAN_PROCESSING_STATUS_UNSPECIFIED",
    LENDER_LOAN_PROCESSING_STATUS_LATE: "LENDER_LOAN_PROCESSING_STATUS_LATE",
    UNRECOGNIZED: "UNRECOGNIZED",
};
function lenderLoanProcessingStatusFromJSON(object) {
    switch (object) {
        case 0:
        case "LENDER_LOAN_PROCESSING_STATUS_UNSPECIFIED":
            return exports.LenderLoanProcessingStatus.LENDER_LOAN_PROCESSING_STATUS_UNSPECIFIED;
        case 1:
        case "LENDER_LOAN_PROCESSING_STATUS_LATE":
            return exports.LenderLoanProcessingStatus.LENDER_LOAN_PROCESSING_STATUS_LATE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return exports.LenderLoanProcessingStatus.UNRECOGNIZED;
    }
}
exports.lenderLoanProcessingStatusFromJSON = lenderLoanProcessingStatusFromJSON;
function lenderLoanProcessingStatusToJSON(object) {
    switch (object) {
        case exports.LenderLoanProcessingStatus.LENDER_LOAN_PROCESSING_STATUS_UNSPECIFIED:
            return "LENDER_LOAN_PROCESSING_STATUS_UNSPECIFIED";
        case exports.LenderLoanProcessingStatus.LENDER_LOAN_PROCESSING_STATUS_LATE:
            return "LENDER_LOAN_PROCESSING_STATUS_LATE";
        case exports.LenderLoanProcessingStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.lenderLoanProcessingStatusToJSON = lenderLoanProcessingStatusToJSON;
exports.LenderLoanTerminatedStatus = {
    LENDER_LOAN_TERMINATED_STATUS_UNSPECIFIED: "LENDER_LOAN_TERMINATED_STATUS_UNSPECIFIED",
    LENDER_LOAN_TERMINATED_STATUS_LIQUIDATED: "LENDER_LOAN_TERMINATED_STATUS_LIQUIDATED",
    UNRECOGNIZED: "UNRECOGNIZED",
};
function lenderLoanTerminatedStatusFromJSON(object) {
    switch (object) {
        case 0:
        case "LENDER_LOAN_TERMINATED_STATUS_UNSPECIFIED":
            return exports.LenderLoanTerminatedStatus.LENDER_LOAN_TERMINATED_STATUS_UNSPECIFIED;
        case 1:
        case "LENDER_LOAN_TERMINATED_STATUS_LIQUIDATED":
            return exports.LenderLoanTerminatedStatus.LENDER_LOAN_TERMINATED_STATUS_LIQUIDATED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return exports.LenderLoanTerminatedStatus.UNRECOGNIZED;
    }
}
exports.lenderLoanTerminatedStatusFromJSON = lenderLoanTerminatedStatusFromJSON;
function lenderLoanTerminatedStatusToJSON(object) {
    switch (object) {
        case exports.LenderLoanTerminatedStatus.LENDER_LOAN_TERMINATED_STATUS_UNSPECIFIED:
            return "LENDER_LOAN_TERMINATED_STATUS_UNSPECIFIED";
        case exports.LenderLoanTerminatedStatus.LENDER_LOAN_TERMINATED_STATUS_LIQUIDATED:
            return "LENDER_LOAN_TERMINATED_STATUS_LIQUIDATED";
        case exports.LenderLoanTerminatedStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.lenderLoanTerminatedStatusToJSON = lenderLoanTerminatedStatusToJSON;
exports.TransactionKind = {
    TRANSACTION_KIND_UNSPECIFIED: "TRANSACTION_KIND_UNSPECIFIED",
    TRANSACTION_KIND_PAYIN_BANK_WIRE: "TRANSACTION_KIND_PAYIN_BANK_WIRE",
    TRANSACTION_KIND_PAYIN_CARD: "TRANSACTION_KIND_PAYIN_CARD",
    TRANSACTION_KIND_PAYIN_CARD_FAIL_TRANSFER: "TRANSACTION_KIND_PAYIN_CARD_FAIL_TRANSFER",
    TRANSACTION_KIND_PAYIN_CARD_OLD: "TRANSACTION_KIND_PAYIN_CARD_OLD",
    TRANSACTION_KIND_PAYIN_DIRECT_DEBIT: "TRANSACTION_KIND_PAYIN_DIRECT_DEBIT",
    TRANSACTION_KIND_PAYOUT_FAIL: "TRANSACTION_KIND_PAYOUT_FAIL",
    TRANSACTION_KIND_PAYOUT_PROCESSING: "TRANSACTION_KIND_PAYOUT_PROCESSING",
    TRANSACTION_KIND_PAYOUT_SUCCESS: "TRANSACTION_KIND_PAYOUT_SUCCESS",
    TRANSACTION_KIND_REFUND: "TRANSACTION_KIND_REFUND",
    TRANSACTION_KIND_REPAY_TRANSFER_REGULAR: "TRANSACTION_KIND_REPAY_TRANSFER_REGULAR",
    TRANSACTION_KIND_SPONSOR_TRANSFER: "TRANSACTION_KIND_SPONSOR_TRANSFER",
    TRANSACTION_KIND_TRANSFER_REGULAR: "TRANSACTION_KIND_TRANSFER_REGULAR",
    TRANSACTION_KIND_TRANSFER_REGULAR_FROM_WALLET: "TRANSACTION_KIND_TRANSFER_REGULAR_FROM_WALLET",
    TRANSACTION_KIND_TRANSFER_REFUND: "TRANSACTION_KIND_TRANSFER_REFUND",
    UNRECOGNIZED: "UNRECOGNIZED",
};
function transactionKindFromJSON(object) {
    switch (object) {
        case 0:
        case "TRANSACTION_KIND_UNSPECIFIED":
            return exports.TransactionKind.TRANSACTION_KIND_UNSPECIFIED;
        case 1:
        case "TRANSACTION_KIND_PAYIN_BANK_WIRE":
            return exports.TransactionKind.TRANSACTION_KIND_PAYIN_BANK_WIRE;
        case 2:
        case "TRANSACTION_KIND_PAYIN_CARD":
            return exports.TransactionKind.TRANSACTION_KIND_PAYIN_CARD;
        case 3:
        case "TRANSACTION_KIND_PAYIN_CARD_FAIL_TRANSFER":
            return exports.TransactionKind.TRANSACTION_KIND_PAYIN_CARD_FAIL_TRANSFER;
        case 4:
        case "TRANSACTION_KIND_PAYIN_CARD_OLD":
            return exports.TransactionKind.TRANSACTION_KIND_PAYIN_CARD_OLD;
        case 5:
        case "TRANSACTION_KIND_PAYIN_DIRECT_DEBIT":
            return exports.TransactionKind.TRANSACTION_KIND_PAYIN_DIRECT_DEBIT;
        case 6:
        case "TRANSACTION_KIND_PAYOUT_FAIL":
            return exports.TransactionKind.TRANSACTION_KIND_PAYOUT_FAIL;
        case 7:
        case "TRANSACTION_KIND_PAYOUT_PROCESSING":
            return exports.TransactionKind.TRANSACTION_KIND_PAYOUT_PROCESSING;
        case 8:
        case "TRANSACTION_KIND_PAYOUT_SUCCESS":
            return exports.TransactionKind.TRANSACTION_KIND_PAYOUT_SUCCESS;
        case 9:
        case "TRANSACTION_KIND_REFUND":
            return exports.TransactionKind.TRANSACTION_KIND_REFUND;
        case 10:
        case "TRANSACTION_KIND_REPAY_TRANSFER_REGULAR":
            return exports.TransactionKind.TRANSACTION_KIND_REPAY_TRANSFER_REGULAR;
        case 11:
        case "TRANSACTION_KIND_SPONSOR_TRANSFER":
            return exports.TransactionKind.TRANSACTION_KIND_SPONSOR_TRANSFER;
        case 12:
        case "TRANSACTION_KIND_TRANSFER_REGULAR":
            return exports.TransactionKind.TRANSACTION_KIND_TRANSFER_REGULAR;
        case 13:
        case "TRANSACTION_KIND_TRANSFER_REGULAR_FROM_WALLET":
            return exports.TransactionKind.TRANSACTION_KIND_TRANSFER_REGULAR_FROM_WALLET;
        case 14:
        case "TRANSACTION_KIND_TRANSFER_REFUND":
            return exports.TransactionKind.TRANSACTION_KIND_TRANSFER_REFUND;
        case -1:
        case "UNRECOGNIZED":
        default:
            return exports.TransactionKind.UNRECOGNIZED;
    }
}
exports.transactionKindFromJSON = transactionKindFromJSON;
function transactionKindToJSON(object) {
    switch (object) {
        case exports.TransactionKind.TRANSACTION_KIND_UNSPECIFIED:
            return "TRANSACTION_KIND_UNSPECIFIED";
        case exports.TransactionKind.TRANSACTION_KIND_PAYIN_BANK_WIRE:
            return "TRANSACTION_KIND_PAYIN_BANK_WIRE";
        case exports.TransactionKind.TRANSACTION_KIND_PAYIN_CARD:
            return "TRANSACTION_KIND_PAYIN_CARD";
        case exports.TransactionKind.TRANSACTION_KIND_PAYIN_CARD_FAIL_TRANSFER:
            return "TRANSACTION_KIND_PAYIN_CARD_FAIL_TRANSFER";
        case exports.TransactionKind.TRANSACTION_KIND_PAYIN_CARD_OLD:
            return "TRANSACTION_KIND_PAYIN_CARD_OLD";
        case exports.TransactionKind.TRANSACTION_KIND_PAYIN_DIRECT_DEBIT:
            return "TRANSACTION_KIND_PAYIN_DIRECT_DEBIT";
        case exports.TransactionKind.TRANSACTION_KIND_PAYOUT_FAIL:
            return "TRANSACTION_KIND_PAYOUT_FAIL";
        case exports.TransactionKind.TRANSACTION_KIND_PAYOUT_PROCESSING:
            return "TRANSACTION_KIND_PAYOUT_PROCESSING";
        case exports.TransactionKind.TRANSACTION_KIND_PAYOUT_SUCCESS:
            return "TRANSACTION_KIND_PAYOUT_SUCCESS";
        case exports.TransactionKind.TRANSACTION_KIND_REFUND:
            return "TRANSACTION_KIND_REFUND";
        case exports.TransactionKind.TRANSACTION_KIND_REPAY_TRANSFER_REGULAR:
            return "TRANSACTION_KIND_REPAY_TRANSFER_REGULAR";
        case exports.TransactionKind.TRANSACTION_KIND_SPONSOR_TRANSFER:
            return "TRANSACTION_KIND_SPONSOR_TRANSFER";
        case exports.TransactionKind.TRANSACTION_KIND_TRANSFER_REGULAR:
            return "TRANSACTION_KIND_TRANSFER_REGULAR";
        case exports.TransactionKind.TRANSACTION_KIND_TRANSFER_REGULAR_FROM_WALLET:
            return "TRANSACTION_KIND_TRANSFER_REGULAR_FROM_WALLET";
        case exports.TransactionKind.TRANSACTION_KIND_TRANSFER_REFUND:
            return "TRANSACTION_KIND_TRANSFER_REFUND";
        case exports.TransactionKind.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.transactionKindToJSON = transactionKindToJSON;
function createBaseRequestAsUser() {
    return { user_id: 0 };
}
exports.RequestAsUser = {
    fromJSON: function (object) {
        return { user_id: isSet(object.user_id) ? globalThis.Number(object.user_id) : 0 };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.user_id !== 0) {
            obj.user_id = Math.round(message.user_id);
        }
        return obj;
    },
    create: function (base) {
        return exports.RequestAsUser.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseRequestAsUser();
        message.user_id = (_a = object.user_id) !== null && _a !== void 0 ? _a : 0;
        return message;
    },
};
function createBaseFinancialStatementRequest() {
    return { year: undefined, req_as_user: undefined };
}
exports.FinancialStatementRequest = {
    fromJSON: function (object) {
        return {
            year: isSet(object.year) ? globalThis.Number(object.year) : undefined,
            req_as_user: isSet(object.req_as_user) ? exports.RequestAsUser.fromJSON(object.req_as_user) : undefined,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.year !== undefined) {
            obj.year = Math.round(message.year);
        }
        if (message.req_as_user !== undefined) {
            obj.req_as_user = exports.RequestAsUser.toJSON(message.req_as_user);
        }
        return obj;
    },
    create: function (base) {
        return exports.FinancialStatementRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseFinancialStatementRequest();
        message.year = (_a = object.year) !== null && _a !== void 0 ? _a : undefined;
        message.req_as_user = (object.req_as_user !== undefined && object.req_as_user !== null)
            ? exports.RequestAsUser.fromPartial(object.req_as_user)
            : undefined;
        return message;
    },
};
function createBaseFinancialStatementResponse() {
    return {
        pledges_total_amount: "0",
        pledges_voucher_amount: "0",
        repaid_social_tax_amount: "0",
        repaid_income_tax_amount: "0",
        repaid_business_tax_amount: "0",
        repaid_capital_amount: "0",
        repaid_interests_amount: "0",
        loss_capital_amount: "0",
    };
}
exports.FinancialStatementResponse = {
    fromJSON: function (object) {
        return {
            pledges_total_amount: isSet(object.pledges_total_amount) ? globalThis.String(object.pledges_total_amount) : "0",
            pledges_voucher_amount: isSet(object.pledges_voucher_amount)
                ? globalThis.String(object.pledges_voucher_amount)
                : "0",
            repaid_social_tax_amount: isSet(object.repaid_social_tax_amount)
                ? globalThis.String(object.repaid_social_tax_amount)
                : "0",
            repaid_income_tax_amount: isSet(object.repaid_income_tax_amount)
                ? globalThis.String(object.repaid_income_tax_amount)
                : "0",
            repaid_business_tax_amount: isSet(object.repaid_business_tax_amount)
                ? globalThis.String(object.repaid_business_tax_amount)
                : "0",
            repaid_capital_amount: isSet(object.repaid_capital_amount)
                ? globalThis.String(object.repaid_capital_amount)
                : "0",
            repaid_interests_amount: isSet(object.repaid_interests_amount)
                ? globalThis.String(object.repaid_interests_amount)
                : "0",
            loss_capital_amount: isSet(object.loss_capital_amount) ? globalThis.String(object.loss_capital_amount) : "0",
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.pledges_total_amount !== "0") {
            obj.pledges_total_amount = message.pledges_total_amount;
        }
        if (message.pledges_voucher_amount !== "0") {
            obj.pledges_voucher_amount = message.pledges_voucher_amount;
        }
        if (message.repaid_social_tax_amount !== "0") {
            obj.repaid_social_tax_amount = message.repaid_social_tax_amount;
        }
        if (message.repaid_income_tax_amount !== "0") {
            obj.repaid_income_tax_amount = message.repaid_income_tax_amount;
        }
        if (message.repaid_business_tax_amount !== "0") {
            obj.repaid_business_tax_amount = message.repaid_business_tax_amount;
        }
        if (message.repaid_capital_amount !== "0") {
            obj.repaid_capital_amount = message.repaid_capital_amount;
        }
        if (message.repaid_interests_amount !== "0") {
            obj.repaid_interests_amount = message.repaid_interests_amount;
        }
        if (message.loss_capital_amount !== "0") {
            obj.loss_capital_amount = message.loss_capital_amount;
        }
        return obj;
    },
    create: function (base) {
        return exports.FinancialStatementResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var message = createBaseFinancialStatementResponse();
        message.pledges_total_amount = (_a = object.pledges_total_amount) !== null && _a !== void 0 ? _a : "0";
        message.pledges_voucher_amount = (_b = object.pledges_voucher_amount) !== null && _b !== void 0 ? _b : "0";
        message.repaid_social_tax_amount = (_c = object.repaid_social_tax_amount) !== null && _c !== void 0 ? _c : "0";
        message.repaid_income_tax_amount = (_d = object.repaid_income_tax_amount) !== null && _d !== void 0 ? _d : "0";
        message.repaid_business_tax_amount = (_e = object.repaid_business_tax_amount) !== null && _e !== void 0 ? _e : "0";
        message.repaid_capital_amount = (_f = object.repaid_capital_amount) !== null && _f !== void 0 ? _f : "0";
        message.repaid_interests_amount = (_g = object.repaid_interests_amount) !== null && _g !== void 0 ? _g : "0";
        message.loss_capital_amount = (_h = object.loss_capital_amount) !== null && _h !== void 0 ? _h : "0";
        return message;
    },
};
function createBaseRepayTermSummariesRequest() {
    return { year: 0, month: undefined, req_as_user: undefined };
}
exports.RepayTermSummariesRequest = {
    fromJSON: function (object) {
        return {
            year: isSet(object.year) ? globalThis.Number(object.year) : 0,
            month: isSet(object.month) ? (0, month_1.monthFromJSON)(object.month) : undefined,
            req_as_user: isSet(object.req_as_user) ? exports.RequestAsUser.fromJSON(object.req_as_user) : undefined,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.year !== 0) {
            obj.year = Math.round(message.year);
        }
        if (message.month !== undefined) {
            obj.month = (0, month_1.monthToJSON)(message.month);
        }
        if (message.req_as_user !== undefined) {
            obj.req_as_user = exports.RequestAsUser.toJSON(message.req_as_user);
        }
        return obj;
    },
    create: function (base) {
        return exports.RepayTermSummariesRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseRepayTermSummariesRequest();
        message.year = (_a = object.year) !== null && _a !== void 0 ? _a : 0;
        message.month = (_b = object.month) !== null && _b !== void 0 ? _b : undefined;
        message.req_as_user = (object.req_as_user !== undefined && object.req_as_user !== null)
            ? exports.RequestAsUser.fromPartial(object.req_as_user)
            : undefined;
        return message;
    },
};
function createBaseRepayTermSummary() {
    return {
        position: 0,
        scheduled_at: "",
        processed_at: undefined,
        succeeded_at: undefined,
        project_slug: "",
        project_title: "",
        capital_amount: 0,
        interest_amount: 0,
        status: repay_terms_1.RepayTermStatus.REPAY_TERM_STATUS_UNSPECIFIED,
        pledge_uuid: "",
        liquidated: false,
        liquidated_at: undefined,
        tax_amount_fr: 0,
        tax_amount_be: 0,
        organization_name: "",
    };
}
exports.RepayTermSummary = {
    fromJSON: function (object) {
        return {
            position: isSet(object.position) ? globalThis.Number(object.position) : 0,
            scheduled_at: isSet(object.scheduled_at) ? globalThis.String(object.scheduled_at) : "",
            processed_at: isSet(object.processed_at) ? globalThis.String(object.processed_at) : undefined,
            succeeded_at: isSet(object.succeeded_at) ? globalThis.String(object.succeeded_at) : undefined,
            project_slug: isSet(object.project_slug) ? globalThis.String(object.project_slug) : "",
            project_title: isSet(object.project_title) ? globalThis.String(object.project_title) : "",
            capital_amount: isSet(object.capital_amount) ? globalThis.Number(object.capital_amount) : 0,
            interest_amount: isSet(object.interest_amount) ? globalThis.Number(object.interest_amount) : 0,
            status: isSet(object.status)
                ? (0, repay_terms_1.repayTermStatusFromJSON)(object.status)
                : repay_terms_1.RepayTermStatus.REPAY_TERM_STATUS_UNSPECIFIED,
            pledge_uuid: isSet(object.pledge_uuid) ? globalThis.String(object.pledge_uuid) : "",
            liquidated: isSet(object.liquidated) ? globalThis.Boolean(object.liquidated) : false,
            liquidated_at: isSet(object.liquidated_at) ? globalThis.String(object.liquidated_at) : undefined,
            tax_amount_fr: isSet(object.tax_amount_fr) ? globalThis.Number(object.tax_amount_fr) : 0,
            tax_amount_be: isSet(object.tax_amount_be) ? globalThis.Number(object.tax_amount_be) : 0,
            organization_name: isSet(object.organization_name) ? globalThis.String(object.organization_name) : "",
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.position !== 0) {
            obj.position = Math.round(message.position);
        }
        if (message.scheduled_at !== "") {
            obj.scheduled_at = message.scheduled_at;
        }
        if (message.processed_at !== undefined) {
            obj.processed_at = message.processed_at;
        }
        if (message.succeeded_at !== undefined) {
            obj.succeeded_at = message.succeeded_at;
        }
        if (message.project_slug !== "") {
            obj.project_slug = message.project_slug;
        }
        if (message.project_title !== "") {
            obj.project_title = message.project_title;
        }
        if (message.capital_amount !== 0) {
            obj.capital_amount = Math.round(message.capital_amount);
        }
        if (message.interest_amount !== 0) {
            obj.interest_amount = Math.round(message.interest_amount);
        }
        if (message.status !== repay_terms_1.RepayTermStatus.REPAY_TERM_STATUS_UNSPECIFIED) {
            obj.status = (0, repay_terms_1.repayTermStatusToJSON)(message.status);
        }
        if (message.pledge_uuid !== "") {
            obj.pledge_uuid = message.pledge_uuid;
        }
        if (message.liquidated !== false) {
            obj.liquidated = message.liquidated;
        }
        if (message.liquidated_at !== undefined) {
            obj.liquidated_at = message.liquidated_at;
        }
        if (message.tax_amount_fr !== 0) {
            obj.tax_amount_fr = Math.round(message.tax_amount_fr);
        }
        if (message.tax_amount_be !== 0) {
            obj.tax_amount_be = Math.round(message.tax_amount_be);
        }
        if (message.organization_name !== "") {
            obj.organization_name = message.organization_name;
        }
        return obj;
    },
    create: function (base) {
        return exports.RepayTermSummary.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        var message = createBaseRepayTermSummary();
        message.position = (_a = object.position) !== null && _a !== void 0 ? _a : 0;
        message.scheduled_at = (_b = object.scheduled_at) !== null && _b !== void 0 ? _b : "";
        message.processed_at = (_c = object.processed_at) !== null && _c !== void 0 ? _c : undefined;
        message.succeeded_at = (_d = object.succeeded_at) !== null && _d !== void 0 ? _d : undefined;
        message.project_slug = (_e = object.project_slug) !== null && _e !== void 0 ? _e : "";
        message.project_title = (_f = object.project_title) !== null && _f !== void 0 ? _f : "";
        message.capital_amount = (_g = object.capital_amount) !== null && _g !== void 0 ? _g : 0;
        message.interest_amount = (_h = object.interest_amount) !== null && _h !== void 0 ? _h : 0;
        message.status = (_j = object.status) !== null && _j !== void 0 ? _j : repay_terms_1.RepayTermStatus.REPAY_TERM_STATUS_UNSPECIFIED;
        message.pledge_uuid = (_k = object.pledge_uuid) !== null && _k !== void 0 ? _k : "";
        message.liquidated = (_l = object.liquidated) !== null && _l !== void 0 ? _l : false;
        message.liquidated_at = (_m = object.liquidated_at) !== null && _m !== void 0 ? _m : undefined;
        message.tax_amount_fr = (_o = object.tax_amount_fr) !== null && _o !== void 0 ? _o : 0;
        message.tax_amount_be = (_p = object.tax_amount_be) !== null && _p !== void 0 ? _p : 0;
        message.organization_name = (_q = object.organization_name) !== null && _q !== void 0 ? _q : "";
        return message;
    },
};
function createBaseRepayTermSummariesResponse() {
    return { repay_terms: [] };
}
exports.RepayTermSummariesResponse = {
    fromJSON: function (object) {
        return {
            repay_terms: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.repay_terms)
                ? object.repay_terms.map(function (e) { return exports.RepayTermSummary.fromJSON(e); })
                : [],
        };
    },
    toJSON: function (message) {
        var _a;
        var obj = {};
        if ((_a = message.repay_terms) === null || _a === void 0 ? void 0 : _a.length) {
            obj.repay_terms = message.repay_terms.map(function (e) { return exports.RepayTermSummary.toJSON(e); });
        }
        return obj;
    },
    create: function (base) {
        return exports.RepayTermSummariesResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseRepayTermSummariesResponse();
        message.repay_terms = ((_a = object.repay_terms) === null || _a === void 0 ? void 0 : _a.map(function (e) { return exports.RepayTermSummary.fromPartial(e); })) || [];
        return message;
    },
};
function createBaseAvailableRepayTermYearsRequest() {
    return { req_as_user: undefined };
}
exports.AvailableRepayTermYearsRequest = {
    fromJSON: function (object) {
        return { req_as_user: isSet(object.req_as_user) ? exports.RequestAsUser.fromJSON(object.req_as_user) : undefined };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.req_as_user !== undefined) {
            obj.req_as_user = exports.RequestAsUser.toJSON(message.req_as_user);
        }
        return obj;
    },
    create: function (base) {
        return exports.AvailableRepayTermYearsRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var message = createBaseAvailableRepayTermYearsRequest();
        message.req_as_user = (object.req_as_user !== undefined && object.req_as_user !== null)
            ? exports.RequestAsUser.fromPartial(object.req_as_user)
            : undefined;
        return message;
    },
};
function createBaseAvailableRepayTermYearsResponse() {
    return { years: [] };
}
exports.AvailableRepayTermYearsResponse = {
    fromJSON: function (object) {
        return { years: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.years) ? object.years.map(function (e) { return globalThis.Number(e); }) : [] };
    },
    toJSON: function (message) {
        var _a;
        var obj = {};
        if ((_a = message.years) === null || _a === void 0 ? void 0 : _a.length) {
            obj.years = message.years.map(function (e) { return Math.round(e); });
        }
        return obj;
    },
    create: function (base) {
        return exports.AvailableRepayTermYearsResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseAvailableRepayTermYearsResponse();
        message.years = ((_a = object.years) === null || _a === void 0 ? void 0 : _a.map(function (e) { return e; })) || [];
        return message;
    },
};
function createBaseLenderLoanSummariesRequest() {
    return {
        pagination: undefined,
        filter_search_by_project_title: undefined,
        filter_by_statuses: [],
        req_as_user: undefined,
    };
}
exports.LenderLoanSummariesRequest = {
    fromJSON: function (object) {
        return {
            pagination: isSet(object.pagination) ? pagination_1.PaginationRequest.fromJSON(object.pagination) : undefined,
            filter_search_by_project_title: isSet(object.filter_search_by_project_title)
                ? globalThis.String(object.filter_search_by_project_title)
                : undefined,
            filter_by_statuses: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.filter_by_statuses)
                ? object.filter_by_statuses.map(function (e) { return lenderLoanSummariesRequestStatusFromJSON(e); })
                : [],
            req_as_user: isSet(object.req_as_user) ? exports.RequestAsUser.fromJSON(object.req_as_user) : undefined,
        };
    },
    toJSON: function (message) {
        var _a;
        var obj = {};
        if (message.pagination !== undefined) {
            obj.pagination = pagination_1.PaginationRequest.toJSON(message.pagination);
        }
        if (message.filter_search_by_project_title !== undefined) {
            obj.filter_search_by_project_title = message.filter_search_by_project_title;
        }
        if ((_a = message.filter_by_statuses) === null || _a === void 0 ? void 0 : _a.length) {
            obj.filter_by_statuses = message.filter_by_statuses.map(function (e) { return lenderLoanSummariesRequestStatusToJSON(e); });
        }
        if (message.req_as_user !== undefined) {
            obj.req_as_user = exports.RequestAsUser.toJSON(message.req_as_user);
        }
        return obj;
    },
    create: function (base) {
        return exports.LenderLoanSummariesRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseLenderLoanSummariesRequest();
        message.pagination = (object.pagination !== undefined && object.pagination !== null)
            ? pagination_1.PaginationRequest.fromPartial(object.pagination)
            : undefined;
        message.filter_search_by_project_title = (_a = object.filter_search_by_project_title) !== null && _a !== void 0 ? _a : undefined;
        message.filter_by_statuses = ((_b = object.filter_by_statuses) === null || _b === void 0 ? void 0 : _b.map(function (e) { return e; })) || [];
        message.req_as_user = (object.req_as_user !== undefined && object.req_as_user !== null)
            ? exports.RequestAsUser.fromPartial(object.req_as_user)
            : undefined;
        return message;
    },
};
function createBaseLenderLoanSummariesResponse() {
    return { loans: [], pagination: undefined };
}
exports.LenderLoanSummariesResponse = {
    fromJSON: function (object) {
        return {
            loans: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.loans) ? object.loans.map(function (e) { return exports.LenderLoanSummary.fromJSON(e); }) : [],
            pagination: isSet(object.pagination) ? pagination_1.PaginationResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON: function (message) {
        var _a;
        var obj = {};
        if ((_a = message.loans) === null || _a === void 0 ? void 0 : _a.length) {
            obj.loans = message.loans.map(function (e) { return exports.LenderLoanSummary.toJSON(e); });
        }
        if (message.pagination !== undefined) {
            obj.pagination = pagination_1.PaginationResponse.toJSON(message.pagination);
        }
        return obj;
    },
    create: function (base) {
        return exports.LenderLoanSummariesResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseLenderLoanSummariesResponse();
        message.loans = ((_a = object.loans) === null || _a === void 0 ? void 0 : _a.map(function (e) { return exports.LenderLoanSummary.fromPartial(e); })) || [];
        message.pagination = (object.pagination !== undefined && object.pagination !== null)
            ? pagination_1.PaginationResponse.fromPartial(object.pagination)
            : undefined;
        return message;
    },
};
function createBaseLenderLoanSummary() {
    return {
        payed_at: "",
        project_title: "",
        organization_name: "",
        invested_amount: 0,
        voucher_amount: 0,
        total_amount: 0,
        repaid_capital_amount: 0,
        remaining_capital_amount: 0,
        total_capital_amount: 0,
        total_interests_amount: undefined,
        repaid_interests_amount: undefined,
        remaining_interests_amount: undefined,
        late_since_at: undefined,
        organization_sector: "",
        interests_ratio: 0,
        capital_repayment_frequency: term_frequency_1.TermFrequency.TERM_FREQUENCY_UNSPECIFIED,
        interests_repayment_frequency: term_frequency_1.TermFrequency.TERM_FREQUENCY_UNSPECIFIED,
        last_repay_at: undefined,
        next_repay_at: undefined,
        term_quantity: 0,
        remaining_term_quantity: 0,
        unpaid_term_quantity: 0,
        unpaid_amount: 0,
        contract_file_key: "",
        pledge_uuid: "",
        loan_created_at: undefined,
        project_slug: "",
        product_kind: product_kind_1.PledgeProductKind.PLEDGE_PRODUCT_KIND_UNSPECIFIED,
        pledge_product_kind: product_kind_1.ProductKind.PRODUCT_KIND_UNSPECIFIED,
        primary_status: exports.LenderLoanSummaryPrimaryStatus.LENDER_LOAN_SUMMARY_PRIMARY_STATUS_UNSPECIFIED,
        late_status: recovery_status_1.RecoveryStatus.RECOVERY_STATUS_UNSPECIFIED,
        processing_status: exports.LenderLoanProcessingStatus.LENDER_LOAN_PROCESSING_STATUS_UNSPECIFIED,
        terminated_status: exports.LenderLoanTerminatedStatus.LENDER_LOAN_TERMINATED_STATUS_UNSPECIFIED,
    };
}
exports.LenderLoanSummary = {
    fromJSON: function (object) {
        return {
            payed_at: isSet(object.payed_at) ? globalThis.String(object.payed_at) : "",
            project_title: isSet(object.project_title) ? globalThis.String(object.project_title) : "",
            organization_name: isSet(object.organization_name) ? globalThis.String(object.organization_name) : "",
            invested_amount: isSet(object.invested_amount) ? globalThis.Number(object.invested_amount) : 0,
            voucher_amount: isSet(object.voucher_amount) ? globalThis.Number(object.voucher_amount) : 0,
            total_amount: isSet(object.total_amount) ? globalThis.Number(object.total_amount) : 0,
            repaid_capital_amount: isSet(object.repaid_capital_amount) ? globalThis.Number(object.repaid_capital_amount) : 0,
            remaining_capital_amount: isSet(object.remaining_capital_amount)
                ? globalThis.Number(object.remaining_capital_amount)
                : 0,
            total_capital_amount: isSet(object.total_capital_amount) ? globalThis.Number(object.total_capital_amount) : 0,
            total_interests_amount: isSet(object.total_interests_amount)
                ? globalThis.Number(object.total_interests_amount)
                : undefined,
            repaid_interests_amount: isSet(object.repaid_interests_amount)
                ? globalThis.Number(object.repaid_interests_amount)
                : undefined,
            remaining_interests_amount: isSet(object.remaining_interests_amount)
                ? globalThis.Number(object.remaining_interests_amount)
                : undefined,
            late_since_at: isSet(object.late_since_at) ? globalThis.String(object.late_since_at) : undefined,
            organization_sector: isSet(object.organization_sector) ? globalThis.String(object.organization_sector) : "",
            interests_ratio: isSet(object.interests_ratio) ? globalThis.Number(object.interests_ratio) : 0,
            capital_repayment_frequency: isSet(object.capital_repayment_frequency)
                ? (0, term_frequency_1.termFrequencyFromJSON)(object.capital_repayment_frequency)
                : term_frequency_1.TermFrequency.TERM_FREQUENCY_UNSPECIFIED,
            interests_repayment_frequency: isSet(object.interests_repayment_frequency)
                ? (0, term_frequency_1.termFrequencyFromJSON)(object.interests_repayment_frequency)
                : term_frequency_1.TermFrequency.TERM_FREQUENCY_UNSPECIFIED,
            last_repay_at: isSet(object.last_repay_at) ? globalThis.String(object.last_repay_at) : undefined,
            next_repay_at: isSet(object.next_repay_at) ? globalThis.String(object.next_repay_at) : undefined,
            term_quantity: isSet(object.term_quantity) ? globalThis.Number(object.term_quantity) : 0,
            remaining_term_quantity: isSet(object.remaining_term_quantity)
                ? globalThis.Number(object.remaining_term_quantity)
                : 0,
            unpaid_term_quantity: isSet(object.unpaid_term_quantity) ? globalThis.Number(object.unpaid_term_quantity) : 0,
            unpaid_amount: isSet(object.unpaid_amount) ? globalThis.Number(object.unpaid_amount) : 0,
            contract_file_key: isSet(object.contract_file_key) ? globalThis.String(object.contract_file_key) : "",
            pledge_uuid: isSet(object.pledge_uuid) ? globalThis.String(object.pledge_uuid) : "",
            loan_created_at: isSet(object.loan_created_at) ? globalThis.String(object.loan_created_at) : undefined,
            project_slug: isSet(object.project_slug) ? globalThis.String(object.project_slug) : "",
            product_kind: isSet(object.product_kind)
                ? (0, product_kind_1.pledgeProductKindFromJSON)(object.product_kind)
                : product_kind_1.PledgeProductKind.PLEDGE_PRODUCT_KIND_UNSPECIFIED,
            pledge_product_kind: isSet(object.pledge_product_kind)
                ? (0, product_kind_1.productKindFromJSON)(object.pledge_product_kind)
                : product_kind_1.ProductKind.PRODUCT_KIND_UNSPECIFIED,
            primary_status: isSet(object.primary_status)
                ? lenderLoanSummaryPrimaryStatusFromJSON(object.primary_status)
                : exports.LenderLoanSummaryPrimaryStatus.LENDER_LOAN_SUMMARY_PRIMARY_STATUS_UNSPECIFIED,
            late_status: isSet(object.late_status)
                ? (0, recovery_status_1.recoveryStatusFromJSON)(object.late_status)
                : recovery_status_1.RecoveryStatus.RECOVERY_STATUS_UNSPECIFIED,
            processing_status: isSet(object.processing_status)
                ? lenderLoanProcessingStatusFromJSON(object.processing_status)
                : exports.LenderLoanProcessingStatus.LENDER_LOAN_PROCESSING_STATUS_UNSPECIFIED,
            terminated_status: isSet(object.terminated_status)
                ? lenderLoanTerminatedStatusFromJSON(object.terminated_status)
                : exports.LenderLoanTerminatedStatus.LENDER_LOAN_TERMINATED_STATUS_UNSPECIFIED,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.payed_at !== "") {
            obj.payed_at = message.payed_at;
        }
        if (message.project_title !== "") {
            obj.project_title = message.project_title;
        }
        if (message.organization_name !== "") {
            obj.organization_name = message.organization_name;
        }
        if (message.invested_amount !== 0) {
            obj.invested_amount = Math.round(message.invested_amount);
        }
        if (message.voucher_amount !== 0) {
            obj.voucher_amount = Math.round(message.voucher_amount);
        }
        if (message.total_amount !== 0) {
            obj.total_amount = Math.round(message.total_amount);
        }
        if (message.repaid_capital_amount !== 0) {
            obj.repaid_capital_amount = Math.round(message.repaid_capital_amount);
        }
        if (message.remaining_capital_amount !== 0) {
            obj.remaining_capital_amount = Math.round(message.remaining_capital_amount);
        }
        if (message.total_capital_amount !== 0) {
            obj.total_capital_amount = Math.round(message.total_capital_amount);
        }
        if (message.total_interests_amount !== undefined) {
            obj.total_interests_amount = Math.round(message.total_interests_amount);
        }
        if (message.repaid_interests_amount !== undefined) {
            obj.repaid_interests_amount = Math.round(message.repaid_interests_amount);
        }
        if (message.remaining_interests_amount !== undefined) {
            obj.remaining_interests_amount = Math.round(message.remaining_interests_amount);
        }
        if (message.late_since_at !== undefined) {
            obj.late_since_at = message.late_since_at;
        }
        if (message.organization_sector !== "") {
            obj.organization_sector = message.organization_sector;
        }
        if (message.interests_ratio !== 0) {
            obj.interests_ratio = message.interests_ratio;
        }
        if (message.capital_repayment_frequency !== term_frequency_1.TermFrequency.TERM_FREQUENCY_UNSPECIFIED) {
            obj.capital_repayment_frequency = (0, term_frequency_1.termFrequencyToJSON)(message.capital_repayment_frequency);
        }
        if (message.interests_repayment_frequency !== term_frequency_1.TermFrequency.TERM_FREQUENCY_UNSPECIFIED) {
            obj.interests_repayment_frequency = (0, term_frequency_1.termFrequencyToJSON)(message.interests_repayment_frequency);
        }
        if (message.last_repay_at !== undefined) {
            obj.last_repay_at = message.last_repay_at;
        }
        if (message.next_repay_at !== undefined) {
            obj.next_repay_at = message.next_repay_at;
        }
        if (message.term_quantity !== 0) {
            obj.term_quantity = Math.round(message.term_quantity);
        }
        if (message.remaining_term_quantity !== 0) {
            obj.remaining_term_quantity = Math.round(message.remaining_term_quantity);
        }
        if (message.unpaid_term_quantity !== 0) {
            obj.unpaid_term_quantity = Math.round(message.unpaid_term_quantity);
        }
        if (message.unpaid_amount !== 0) {
            obj.unpaid_amount = Math.round(message.unpaid_amount);
        }
        if (message.contract_file_key !== "") {
            obj.contract_file_key = message.contract_file_key;
        }
        if (message.pledge_uuid !== "") {
            obj.pledge_uuid = message.pledge_uuid;
        }
        if (message.loan_created_at !== undefined) {
            obj.loan_created_at = message.loan_created_at;
        }
        if (message.project_slug !== "") {
            obj.project_slug = message.project_slug;
        }
        if (message.product_kind !== product_kind_1.PledgeProductKind.PLEDGE_PRODUCT_KIND_UNSPECIFIED) {
            obj.product_kind = (0, product_kind_1.pledgeProductKindToJSON)(message.product_kind);
        }
        if (message.pledge_product_kind !== product_kind_1.ProductKind.PRODUCT_KIND_UNSPECIFIED) {
            obj.pledge_product_kind = (0, product_kind_1.productKindToJSON)(message.pledge_product_kind);
        }
        if (message.primary_status !== exports.LenderLoanSummaryPrimaryStatus.LENDER_LOAN_SUMMARY_PRIMARY_STATUS_UNSPECIFIED) {
            obj.primary_status = lenderLoanSummaryPrimaryStatusToJSON(message.primary_status);
        }
        if (message.late_status !== recovery_status_1.RecoveryStatus.RECOVERY_STATUS_UNSPECIFIED) {
            obj.late_status = (0, recovery_status_1.recoveryStatusToJSON)(message.late_status);
        }
        if (message.processing_status !== exports.LenderLoanProcessingStatus.LENDER_LOAN_PROCESSING_STATUS_UNSPECIFIED) {
            obj.processing_status = lenderLoanProcessingStatusToJSON(message.processing_status);
        }
        if (message.terminated_status !== exports.LenderLoanTerminatedStatus.LENDER_LOAN_TERMINATED_STATUS_UNSPECIFIED) {
            obj.terminated_status = lenderLoanTerminatedStatusToJSON(message.terminated_status);
        }
        return obj;
    },
    create: function (base) {
        return exports.LenderLoanSummary.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8;
        var message = createBaseLenderLoanSummary();
        message.payed_at = (_a = object.payed_at) !== null && _a !== void 0 ? _a : "";
        message.project_title = (_b = object.project_title) !== null && _b !== void 0 ? _b : "";
        message.organization_name = (_c = object.organization_name) !== null && _c !== void 0 ? _c : "";
        message.invested_amount = (_d = object.invested_amount) !== null && _d !== void 0 ? _d : 0;
        message.voucher_amount = (_e = object.voucher_amount) !== null && _e !== void 0 ? _e : 0;
        message.total_amount = (_f = object.total_amount) !== null && _f !== void 0 ? _f : 0;
        message.repaid_capital_amount = (_g = object.repaid_capital_amount) !== null && _g !== void 0 ? _g : 0;
        message.remaining_capital_amount = (_h = object.remaining_capital_amount) !== null && _h !== void 0 ? _h : 0;
        message.total_capital_amount = (_j = object.total_capital_amount) !== null && _j !== void 0 ? _j : 0;
        message.total_interests_amount = (_k = object.total_interests_amount) !== null && _k !== void 0 ? _k : undefined;
        message.repaid_interests_amount = (_l = object.repaid_interests_amount) !== null && _l !== void 0 ? _l : undefined;
        message.remaining_interests_amount = (_m = object.remaining_interests_amount) !== null && _m !== void 0 ? _m : undefined;
        message.late_since_at = (_o = object.late_since_at) !== null && _o !== void 0 ? _o : undefined;
        message.organization_sector = (_p = object.organization_sector) !== null && _p !== void 0 ? _p : "";
        message.interests_ratio = (_q = object.interests_ratio) !== null && _q !== void 0 ? _q : 0;
        message.capital_repayment_frequency = (_r = object.capital_repayment_frequency) !== null && _r !== void 0 ? _r : term_frequency_1.TermFrequency.TERM_FREQUENCY_UNSPECIFIED;
        message.interests_repayment_frequency = (_s = object.interests_repayment_frequency) !== null && _s !== void 0 ? _s : term_frequency_1.TermFrequency.TERM_FREQUENCY_UNSPECIFIED;
        message.last_repay_at = (_t = object.last_repay_at) !== null && _t !== void 0 ? _t : undefined;
        message.next_repay_at = (_u = object.next_repay_at) !== null && _u !== void 0 ? _u : undefined;
        message.term_quantity = (_v = object.term_quantity) !== null && _v !== void 0 ? _v : 0;
        message.remaining_term_quantity = (_w = object.remaining_term_quantity) !== null && _w !== void 0 ? _w : 0;
        message.unpaid_term_quantity = (_x = object.unpaid_term_quantity) !== null && _x !== void 0 ? _x : 0;
        message.unpaid_amount = (_y = object.unpaid_amount) !== null && _y !== void 0 ? _y : 0;
        message.contract_file_key = (_z = object.contract_file_key) !== null && _z !== void 0 ? _z : "";
        message.pledge_uuid = (_0 = object.pledge_uuid) !== null && _0 !== void 0 ? _0 : "";
        message.loan_created_at = (_1 = object.loan_created_at) !== null && _1 !== void 0 ? _1 : undefined;
        message.project_slug = (_2 = object.project_slug) !== null && _2 !== void 0 ? _2 : "";
        message.product_kind = (_3 = object.product_kind) !== null && _3 !== void 0 ? _3 : product_kind_1.PledgeProductKind.PLEDGE_PRODUCT_KIND_UNSPECIFIED;
        message.pledge_product_kind = (_4 = object.pledge_product_kind) !== null && _4 !== void 0 ? _4 : product_kind_1.ProductKind.PRODUCT_KIND_UNSPECIFIED;
        message.primary_status = (_5 = object.primary_status) !== null && _5 !== void 0 ? _5 : exports.LenderLoanSummaryPrimaryStatus.LENDER_LOAN_SUMMARY_PRIMARY_STATUS_UNSPECIFIED;
        message.late_status = (_6 = object.late_status) !== null && _6 !== void 0 ? _6 : recovery_status_1.RecoveryStatus.RECOVERY_STATUS_UNSPECIFIED;
        message.processing_status = (_7 = object.processing_status) !== null && _7 !== void 0 ? _7 : exports.LenderLoanProcessingStatus.LENDER_LOAN_PROCESSING_STATUS_UNSPECIFIED;
        message.terminated_status = (_8 = object.terminated_status) !== null && _8 !== void 0 ? _8 : exports.LenderLoanTerminatedStatus.LENDER_LOAN_TERMINATED_STATUS_UNSPECIFIED;
        return message;
    },
};
function createBaseLenderPortfolioSummaryRequest() {
    return { req_as_user: undefined };
}
exports.LenderPortfolioSummaryRequest = {
    fromJSON: function (object) {
        return { req_as_user: isSet(object.req_as_user) ? exports.RequestAsUser.fromJSON(object.req_as_user) : undefined };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.req_as_user !== undefined) {
            obj.req_as_user = exports.RequestAsUser.toJSON(message.req_as_user);
        }
        return obj;
    },
    create: function (base) {
        return exports.LenderPortfolioSummaryRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var message = createBaseLenderPortfolioSummaryRequest();
        message.req_as_user = (object.req_as_user !== undefined && object.req_as_user !== null)
            ? exports.RequestAsUser.fromPartial(object.req_as_user)
            : undefined;
        return message;
    },
};
function createBaseLenderPortfolioSummaryResponse() {
    return {
        loans_waiting_generation_count: 0,
        loans_waiting_generation_invested_amount: 0,
        first_investment_at: "",
        distinct_collects_count: 0,
        invested_amount: 0,
        loans_count: 0,
        loans_terminated_count: 0,
        loans_late_count: 0,
        loans_processing_count: 0,
        invested_amount_per_sector: {},
        remaining_capital_amount: 0,
        capital_amount: 0,
        impact_households_supplied: 0,
        impact_jobs_created_or_maintained: 0,
        impact_preserved_agricultural_area: 0,
        provisions_amount: 0,
        losses_amount: 0,
        xirr_with_vouchers_as_percentage: 0,
        xirr_computed_at: "",
        xirr_with_voucher_using_miimo_provision_as_percentage: undefined,
        xirr_using_miimo_provision_computed_at: undefined,
    };
}
exports.LenderPortfolioSummaryResponse = {
    fromJSON: function (object) {
        return {
            loans_waiting_generation_count: isSet(object.loans_waiting_generation_count)
                ? globalThis.Number(object.loans_waiting_generation_count)
                : 0,
            loans_waiting_generation_invested_amount: isSet(object.loans_waiting_generation_invested_amount)
                ? globalThis.Number(object.loans_waiting_generation_invested_amount)
                : 0,
            first_investment_at: isSet(object.first_investment_at) ? globalThis.String(object.first_investment_at) : "",
            distinct_collects_count: isSet(object.distinct_collects_count)
                ? globalThis.Number(object.distinct_collects_count)
                : 0,
            invested_amount: isSet(object.invested_amount) ? globalThis.Number(object.invested_amount) : 0,
            loans_count: isSet(object.loans_count) ? globalThis.Number(object.loans_count) : 0,
            loans_terminated_count: isSet(object.loans_terminated_count)
                ? globalThis.Number(object.loans_terminated_count)
                : 0,
            loans_late_count: isSet(object.loans_late_count) ? globalThis.Number(object.loans_late_count) : 0,
            loans_processing_count: isSet(object.loans_processing_count)
                ? globalThis.Number(object.loans_processing_count)
                : 0,
            invested_amount_per_sector: isObject(object.invested_amount_per_sector)
                ? Object.entries(object.invested_amount_per_sector).reduce(function (acc, _a) {
                    var key = _a[0], value = _a[1];
                    acc[key] = Number(value);
                    return acc;
                }, {})
                : {},
            remaining_capital_amount: isSet(object.remaining_capital_amount)
                ? globalThis.Number(object.remaining_capital_amount)
                : 0,
            capital_amount: isSet(object.capital_amount) ? globalThis.Number(object.capital_amount) : 0,
            impact_households_supplied: isSet(object.impact_households_supplied)
                ? globalThis.Number(object.impact_households_supplied)
                : 0,
            impact_jobs_created_or_maintained: isSet(object.impact_jobs_created_or_maintained)
                ? globalThis.Number(object.impact_jobs_created_or_maintained)
                : 0,
            impact_preserved_agricultural_area: isSet(object.impact_preserved_agricultural_area)
                ? globalThis.Number(object.impact_preserved_agricultural_area)
                : 0,
            provisions_amount: isSet(object.provisions_amount) ? globalThis.Number(object.provisions_amount) : 0,
            losses_amount: isSet(object.losses_amount) ? globalThis.Number(object.losses_amount) : 0,
            xirr_with_vouchers_as_percentage: isSet(object.xirr_with_vouchers_as_percentage)
                ? globalThis.Number(object.xirr_with_vouchers_as_percentage)
                : 0,
            xirr_computed_at: isSet(object.xirr_computed_at) ? globalThis.String(object.xirr_computed_at) : "",
            xirr_with_voucher_using_miimo_provision_as_percentage: isSet(object.xirr_with_voucher_using_miimo_provision_as_percentage)
                ? globalThis.Number(object.xirr_with_voucher_using_miimo_provision_as_percentage)
                : undefined,
            xirr_using_miimo_provision_computed_at: isSet(object.xirr_using_miimo_provision_computed_at)
                ? globalThis.String(object.xirr_using_miimo_provision_computed_at)
                : undefined,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.loans_waiting_generation_count !== 0) {
            obj.loans_waiting_generation_count = Math.round(message.loans_waiting_generation_count);
        }
        if (message.loans_waiting_generation_invested_amount !== 0) {
            obj.loans_waiting_generation_invested_amount = Math.round(message.loans_waiting_generation_invested_amount);
        }
        if (message.first_investment_at !== "") {
            obj.first_investment_at = message.first_investment_at;
        }
        if (message.distinct_collects_count !== 0) {
            obj.distinct_collects_count = Math.round(message.distinct_collects_count);
        }
        if (message.invested_amount !== 0) {
            obj.invested_amount = Math.round(message.invested_amount);
        }
        if (message.loans_count !== 0) {
            obj.loans_count = Math.round(message.loans_count);
        }
        if (message.loans_terminated_count !== 0) {
            obj.loans_terminated_count = Math.round(message.loans_terminated_count);
        }
        if (message.loans_late_count !== 0) {
            obj.loans_late_count = Math.round(message.loans_late_count);
        }
        if (message.loans_processing_count !== 0) {
            obj.loans_processing_count = Math.round(message.loans_processing_count);
        }
        if (message.invested_amount_per_sector) {
            var entries = Object.entries(message.invested_amount_per_sector);
            if (entries.length > 0) {
                obj.invested_amount_per_sector = {};
                entries.forEach(function (_a) {
                    var k = _a[0], v = _a[1];
                    obj.invested_amount_per_sector[k] = Math.round(v);
                });
            }
        }
        if (message.remaining_capital_amount !== 0) {
            obj.remaining_capital_amount = Math.round(message.remaining_capital_amount);
        }
        if (message.capital_amount !== 0) {
            obj.capital_amount = Math.round(message.capital_amount);
        }
        if (message.impact_households_supplied !== 0) {
            obj.impact_households_supplied = Math.round(message.impact_households_supplied);
        }
        if (message.impact_jobs_created_or_maintained !== 0) {
            obj.impact_jobs_created_or_maintained = Math.round(message.impact_jobs_created_or_maintained);
        }
        if (message.impact_preserved_agricultural_area !== 0) {
            obj.impact_preserved_agricultural_area = Math.round(message.impact_preserved_agricultural_area);
        }
        if (message.provisions_amount !== 0) {
            obj.provisions_amount = Math.round(message.provisions_amount);
        }
        if (message.losses_amount !== 0) {
            obj.losses_amount = Math.round(message.losses_amount);
        }
        if (message.xirr_with_vouchers_as_percentage !== 0) {
            obj.xirr_with_vouchers_as_percentage = message.xirr_with_vouchers_as_percentage;
        }
        if (message.xirr_computed_at !== "") {
            obj.xirr_computed_at = message.xirr_computed_at;
        }
        if (message.xirr_with_voucher_using_miimo_provision_as_percentage !== undefined) {
            obj.xirr_with_voucher_using_miimo_provision_as_percentage =
                message.xirr_with_voucher_using_miimo_provision_as_percentage;
        }
        if (message.xirr_using_miimo_provision_computed_at !== undefined) {
            obj.xirr_using_miimo_provision_computed_at = message.xirr_using_miimo_provision_computed_at;
        }
        return obj;
    },
    create: function (base) {
        return exports.LenderPortfolioSummaryResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
        var message = createBaseLenderPortfolioSummaryResponse();
        message.loans_waiting_generation_count = (_a = object.loans_waiting_generation_count) !== null && _a !== void 0 ? _a : 0;
        message.loans_waiting_generation_invested_amount = (_b = object.loans_waiting_generation_invested_amount) !== null && _b !== void 0 ? _b : 0;
        message.first_investment_at = (_c = object.first_investment_at) !== null && _c !== void 0 ? _c : "";
        message.distinct_collects_count = (_d = object.distinct_collects_count) !== null && _d !== void 0 ? _d : 0;
        message.invested_amount = (_e = object.invested_amount) !== null && _e !== void 0 ? _e : 0;
        message.loans_count = (_f = object.loans_count) !== null && _f !== void 0 ? _f : 0;
        message.loans_terminated_count = (_g = object.loans_terminated_count) !== null && _g !== void 0 ? _g : 0;
        message.loans_late_count = (_h = object.loans_late_count) !== null && _h !== void 0 ? _h : 0;
        message.loans_processing_count = (_j = object.loans_processing_count) !== null && _j !== void 0 ? _j : 0;
        message.invested_amount_per_sector = Object.entries((_k = object.invested_amount_per_sector) !== null && _k !== void 0 ? _k : {}).reduce(function (acc, _a) {
            var key = _a[0], value = _a[1];
            if (value !== undefined) {
                acc[key] = globalThis.Number(value);
            }
            return acc;
        }, {});
        message.remaining_capital_amount = (_l = object.remaining_capital_amount) !== null && _l !== void 0 ? _l : 0;
        message.capital_amount = (_m = object.capital_amount) !== null && _m !== void 0 ? _m : 0;
        message.impact_households_supplied = (_o = object.impact_households_supplied) !== null && _o !== void 0 ? _o : 0;
        message.impact_jobs_created_or_maintained = (_p = object.impact_jobs_created_or_maintained) !== null && _p !== void 0 ? _p : 0;
        message.impact_preserved_agricultural_area = (_q = object.impact_preserved_agricultural_area) !== null && _q !== void 0 ? _q : 0;
        message.provisions_amount = (_r = object.provisions_amount) !== null && _r !== void 0 ? _r : 0;
        message.losses_amount = (_s = object.losses_amount) !== null && _s !== void 0 ? _s : 0;
        message.xirr_with_vouchers_as_percentage = (_t = object.xirr_with_vouchers_as_percentage) !== null && _t !== void 0 ? _t : 0;
        message.xirr_computed_at = (_u = object.xirr_computed_at) !== null && _u !== void 0 ? _u : "";
        message.xirr_with_voucher_using_miimo_provision_as_percentage =
            (_v = object.xirr_with_voucher_using_miimo_provision_as_percentage) !== null && _v !== void 0 ? _v : undefined;
        message.xirr_using_miimo_provision_computed_at = (_w = object.xirr_using_miimo_provision_computed_at) !== null && _w !== void 0 ? _w : undefined;
        return message;
    },
};
function createBaseLenderPortfolioSummaryResponse_InvestedAmountPerSectorEntry() {
    return { key: "", value: 0 };
}
exports.LenderPortfolioSummaryResponse_InvestedAmountPerSectorEntry = {
    fromJSON: function (object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : "",
            value: isSet(object.value) ? globalThis.Number(object.value) : 0,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== 0) {
            obj.value = Math.round(message.value);
        }
        return obj;
    },
    create: function (base) {
        return exports.LenderPortfolioSummaryResponse_InvestedAmountPerSectorEntry.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseLenderPortfolioSummaryResponse_InvestedAmountPerSectorEntry();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "";
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : 0;
        return message;
    },
};
function createBaseExtractLenderLoanSummariesXLSRequest() {
    return { req_as_user: undefined };
}
exports.ExtractLenderLoanSummariesXLSRequest = {
    fromJSON: function (object) {
        return { req_as_user: isSet(object.req_as_user) ? exports.RequestAsUser.fromJSON(object.req_as_user) : undefined };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.req_as_user !== undefined) {
            obj.req_as_user = exports.RequestAsUser.toJSON(message.req_as_user);
        }
        return obj;
    },
    create: function (base) {
        return exports.ExtractLenderLoanSummariesXLSRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var message = createBaseExtractLenderLoanSummariesXLSRequest();
        message.req_as_user = (object.req_as_user !== undefined && object.req_as_user !== null)
            ? exports.RequestAsUser.fromPartial(object.req_as_user)
            : undefined;
        return message;
    },
};
function createBaseExtractLenderLoanSummariesXLSResponse() {
    return { content: new Uint8Array(0) };
}
exports.ExtractLenderLoanSummariesXLSResponse = {
    fromJSON: function (object) {
        return { content: isSet(object.content) ? bytesFromBase64(object.content) : new Uint8Array(0) };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.content.length !== 0) {
            obj.content = base64FromBytes(message.content);
        }
        return obj;
    },
    create: function (base) {
        return exports.ExtractLenderLoanSummariesXLSResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseExtractLenderLoanSummariesXLSResponse();
        message.content = (_a = object.content) !== null && _a !== void 0 ? _a : new Uint8Array(0);
        return message;
    },
};
function createBaseLendingNotesRequest() {
    return { pledge_uuid: "", req_as_user: undefined };
}
exports.LendingNotesRequest = {
    fromJSON: function (object) {
        return {
            pledge_uuid: isSet(object.pledge_uuid) ? globalThis.String(object.pledge_uuid) : "",
            req_as_user: isSet(object.req_as_user) ? exports.RequestAsUser.fromJSON(object.req_as_user) : undefined,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.pledge_uuid !== "") {
            obj.pledge_uuid = message.pledge_uuid;
        }
        if (message.req_as_user !== undefined) {
            obj.req_as_user = exports.RequestAsUser.toJSON(message.req_as_user);
        }
        return obj;
    },
    create: function (base) {
        return exports.LendingNotesRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseLendingNotesRequest();
        message.pledge_uuid = (_a = object.pledge_uuid) !== null && _a !== void 0 ? _a : "";
        message.req_as_user = (object.req_as_user !== undefined && object.req_as_user !== null)
            ? exports.RequestAsUser.fromPartial(object.req_as_user)
            : undefined;
        return message;
    },
};
function createBaseLendingNotesResponse() {
    return { notes: [] };
}
exports.LendingNotesResponse = {
    fromJSON: function (object) {
        return {
            notes: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.notes) ? object.notes.map(function (e) { return exports.LendingNote.fromJSON(e); }) : [],
        };
    },
    toJSON: function (message) {
        var _a;
        var obj = {};
        if ((_a = message.notes) === null || _a === void 0 ? void 0 : _a.length) {
            obj.notes = message.notes.map(function (e) { return exports.LendingNote.toJSON(e); });
        }
        return obj;
    },
    create: function (base) {
        return exports.LendingNotesResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseLendingNotesResponse();
        message.notes = ((_a = object.notes) === null || _a === void 0 ? void 0 : _a.map(function (e) { return exports.LendingNote.fromPartial(e); })) || [];
        return message;
    },
};
function createBaseLendingNote() {
    return { id: 0, title: "", content: "", published_at: "", document: undefined };
}
exports.LendingNote = {
    fromJSON: function (object) {
        return {
            id: isSet(object.id) ? globalThis.Number(object.id) : 0,
            title: isSet(object.title) ? globalThis.String(object.title) : "",
            content: isSet(object.content) ? globalThis.String(object.content) : "",
            published_at: isSet(object.published_at) ? globalThis.String(object.published_at) : "",
            document: isSet(object.document) ? exports.LendingNote_File.fromJSON(object.document) : undefined,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.id !== 0) {
            obj.id = Math.round(message.id);
        }
        if (message.title !== "") {
            obj.title = message.title;
        }
        if (message.content !== "") {
            obj.content = message.content;
        }
        if (message.published_at !== "") {
            obj.published_at = message.published_at;
        }
        if (message.document !== undefined) {
            obj.document = exports.LendingNote_File.toJSON(message.document);
        }
        return obj;
    },
    create: function (base) {
        return exports.LendingNote.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d;
        var message = createBaseLendingNote();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : 0;
        message.title = (_b = object.title) !== null && _b !== void 0 ? _b : "";
        message.content = (_c = object.content) !== null && _c !== void 0 ? _c : "";
        message.published_at = (_d = object.published_at) !== null && _d !== void 0 ? _d : "";
        message.document = (object.document !== undefined && object.document !== null)
            ? exports.LendingNote_File.fromPartial(object.document)
            : undefined;
        return message;
    },
};
function createBaseLendingNote_File() {
    return { name: "", content_type: "", file_size: 0 };
}
exports.LendingNote_File = {
    fromJSON: function (object) {
        return {
            name: isSet(object.name) ? globalThis.String(object.name) : "",
            content_type: isSet(object.content_type) ? globalThis.String(object.content_type) : "",
            file_size: isSet(object.file_size) ? globalThis.Number(object.file_size) : 0,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.name !== "") {
            obj.name = message.name;
        }
        if (message.content_type !== "") {
            obj.content_type = message.content_type;
        }
        if (message.file_size !== 0) {
            obj.file_size = Math.round(message.file_size);
        }
        return obj;
    },
    create: function (base) {
        return exports.LendingNote_File.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c;
        var message = createBaseLendingNote_File();
        message.name = (_a = object.name) !== null && _a !== void 0 ? _a : "";
        message.content_type = (_b = object.content_type) !== null && _b !== void 0 ? _b : "";
        message.file_size = (_c = object.file_size) !== null && _c !== void 0 ? _c : 0;
        return message;
    },
};
function createBaseLenderLoanSummaryRequest() {
    return { pledge_uuid: "", req_as_user: undefined };
}
exports.LenderLoanSummaryRequest = {
    fromJSON: function (object) {
        return {
            pledge_uuid: isSet(object.pledge_uuid) ? globalThis.String(object.pledge_uuid) : "",
            req_as_user: isSet(object.req_as_user) ? exports.RequestAsUser.fromJSON(object.req_as_user) : undefined,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.pledge_uuid !== "") {
            obj.pledge_uuid = message.pledge_uuid;
        }
        if (message.req_as_user !== undefined) {
            obj.req_as_user = exports.RequestAsUser.toJSON(message.req_as_user);
        }
        return obj;
    },
    create: function (base) {
        return exports.LenderLoanSummaryRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseLenderLoanSummaryRequest();
        message.pledge_uuid = (_a = object.pledge_uuid) !== null && _a !== void 0 ? _a : "";
        message.req_as_user = (object.req_as_user !== undefined && object.req_as_user !== null)
            ? exports.RequestAsUser.fromPartial(object.req_as_user)
            : undefined;
        return message;
    },
};
function createBaseRepayTerm() {
    return {
        position: 0,
        scheduled_at: "",
        processed_at: undefined,
        succeeded_at: undefined,
        capital_amount_i: 0,
        interest_amount_i: 0,
        income_tax_amount_i: 0,
        business_tax_amount_i: 0,
        social_tax_amount_i: 0,
        tax_amount_be_i: 0,
        net_interest_amount_i: 0,
    };
}
exports.RepayTerm = {
    fromJSON: function (object) {
        return {
            position: isSet(object.position) ? globalThis.Number(object.position) : 0,
            scheduled_at: isSet(object.scheduled_at) ? globalThis.String(object.scheduled_at) : "",
            processed_at: isSet(object.processed_at) ? globalThis.String(object.processed_at) : undefined,
            succeeded_at: isSet(object.succeeded_at) ? globalThis.String(object.succeeded_at) : undefined,
            capital_amount_i: isSet(object.capital_amount_i) ? globalThis.Number(object.capital_amount_i) : 0,
            interest_amount_i: isSet(object.interest_amount_i) ? globalThis.Number(object.interest_amount_i) : 0,
            income_tax_amount_i: isSet(object.income_tax_amount_i) ? globalThis.Number(object.income_tax_amount_i) : 0,
            business_tax_amount_i: isSet(object.business_tax_amount_i) ? globalThis.Number(object.business_tax_amount_i) : 0,
            social_tax_amount_i: isSet(object.social_tax_amount_i) ? globalThis.Number(object.social_tax_amount_i) : 0,
            tax_amount_be_i: isSet(object.tax_amount_be_i) ? globalThis.Number(object.tax_amount_be_i) : 0,
            net_interest_amount_i: isSet(object.net_interest_amount_i) ? globalThis.Number(object.net_interest_amount_i) : 0,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.position !== 0) {
            obj.position = Math.round(message.position);
        }
        if (message.scheduled_at !== "") {
            obj.scheduled_at = message.scheduled_at;
        }
        if (message.processed_at !== undefined) {
            obj.processed_at = message.processed_at;
        }
        if (message.succeeded_at !== undefined) {
            obj.succeeded_at = message.succeeded_at;
        }
        if (message.capital_amount_i !== 0) {
            obj.capital_amount_i = Math.round(message.capital_amount_i);
        }
        if (message.interest_amount_i !== 0) {
            obj.interest_amount_i = Math.round(message.interest_amount_i);
        }
        if (message.income_tax_amount_i !== 0) {
            obj.income_tax_amount_i = Math.round(message.income_tax_amount_i);
        }
        if (message.business_tax_amount_i !== 0) {
            obj.business_tax_amount_i = Math.round(message.business_tax_amount_i);
        }
        if (message.social_tax_amount_i !== 0) {
            obj.social_tax_amount_i = Math.round(message.social_tax_amount_i);
        }
        if (message.tax_amount_be_i !== 0) {
            obj.tax_amount_be_i = Math.round(message.tax_amount_be_i);
        }
        if (message.net_interest_amount_i !== 0) {
            obj.net_interest_amount_i = Math.round(message.net_interest_amount_i);
        }
        return obj;
    },
    create: function (base) {
        return exports.RepayTerm.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        var message = createBaseRepayTerm();
        message.position = (_a = object.position) !== null && _a !== void 0 ? _a : 0;
        message.scheduled_at = (_b = object.scheduled_at) !== null && _b !== void 0 ? _b : "";
        message.processed_at = (_c = object.processed_at) !== null && _c !== void 0 ? _c : undefined;
        message.succeeded_at = (_d = object.succeeded_at) !== null && _d !== void 0 ? _d : undefined;
        message.capital_amount_i = (_e = object.capital_amount_i) !== null && _e !== void 0 ? _e : 0;
        message.interest_amount_i = (_f = object.interest_amount_i) !== null && _f !== void 0 ? _f : 0;
        message.income_tax_amount_i = (_g = object.income_tax_amount_i) !== null && _g !== void 0 ? _g : 0;
        message.business_tax_amount_i = (_h = object.business_tax_amount_i) !== null && _h !== void 0 ? _h : 0;
        message.social_tax_amount_i = (_j = object.social_tax_amount_i) !== null && _j !== void 0 ? _j : 0;
        message.tax_amount_be_i = (_k = object.tax_amount_be_i) !== null && _k !== void 0 ? _k : 0;
        message.net_interest_amount_i = (_l = object.net_interest_amount_i) !== null && _l !== void 0 ? _l : 0;
        return message;
    },
};
function createBaseLenderLoanSummaryResponse() {
    return { repay_terms: [], loan: undefined };
}
exports.LenderLoanSummaryResponse = {
    fromJSON: function (object) {
        return {
            repay_terms: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.repay_terms)
                ? object.repay_terms.map(function (e) { return exports.RepayTerm.fromJSON(e); })
                : [],
            loan: isSet(object.loan) ? exports.LenderLoanSummary.fromJSON(object.loan) : undefined,
        };
    },
    toJSON: function (message) {
        var _a;
        var obj = {};
        if ((_a = message.repay_terms) === null || _a === void 0 ? void 0 : _a.length) {
            obj.repay_terms = message.repay_terms.map(function (e) { return exports.RepayTerm.toJSON(e); });
        }
        if (message.loan !== undefined) {
            obj.loan = exports.LenderLoanSummary.toJSON(message.loan);
        }
        return obj;
    },
    create: function (base) {
        return exports.LenderLoanSummaryResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseLenderLoanSummaryResponse();
        message.repay_terms = ((_a = object.repay_terms) === null || _a === void 0 ? void 0 : _a.map(function (e) { return exports.RepayTerm.fromPartial(e); })) || [];
        message.loan = (object.loan !== undefined && object.loan !== null)
            ? exports.LenderLoanSummary.fromPartial(object.loan)
            : undefined;
        return message;
    },
};
function createBaseTransactionsRequest() {
    return { pagination: undefined, kind_filter: [], req_as_user: undefined };
}
exports.TransactionsRequest = {
    fromJSON: function (object) {
        return {
            pagination: isSet(object.pagination) ? pagination_1.PaginationRequest.fromJSON(object.pagination) : undefined,
            kind_filter: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.kind_filter)
                ? object.kind_filter.map(function (e) { return transactionKindFromJSON(e); })
                : [],
            req_as_user: isSet(object.req_as_user) ? exports.RequestAsUser.fromJSON(object.req_as_user) : undefined,
        };
    },
    toJSON: function (message) {
        var _a;
        var obj = {};
        if (message.pagination !== undefined) {
            obj.pagination = pagination_1.PaginationRequest.toJSON(message.pagination);
        }
        if ((_a = message.kind_filter) === null || _a === void 0 ? void 0 : _a.length) {
            obj.kind_filter = message.kind_filter.map(function (e) { return transactionKindToJSON(e); });
        }
        if (message.req_as_user !== undefined) {
            obj.req_as_user = exports.RequestAsUser.toJSON(message.req_as_user);
        }
        return obj;
    },
    create: function (base) {
        return exports.TransactionsRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseTransactionsRequest();
        message.pagination = (object.pagination !== undefined && object.pagination !== null)
            ? pagination_1.PaginationRequest.fromPartial(object.pagination)
            : undefined;
        message.kind_filter = ((_a = object.kind_filter) === null || _a === void 0 ? void 0 : _a.map(function (e) { return e; })) || [];
        message.req_as_user = (object.req_as_user !== undefined && object.req_as_user !== null)
            ? exports.RequestAsUser.fromPartial(object.req_as_user)
            : undefined;
        return message;
    },
};
function createBaseTransactionsResponse() {
    return { transactions: [], pagination: undefined };
}
exports.TransactionsResponse = {
    fromJSON: function (object) {
        return {
            transactions: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.transactions)
                ? object.transactions.map(function (e) { return exports.Transaction.fromJSON(e); })
                : [],
            pagination: isSet(object.pagination) ? pagination_1.PaginationResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON: function (message) {
        var _a;
        var obj = {};
        if ((_a = message.transactions) === null || _a === void 0 ? void 0 : _a.length) {
            obj.transactions = message.transactions.map(function (e) { return exports.Transaction.toJSON(e); });
        }
        if (message.pagination !== undefined) {
            obj.pagination = pagination_1.PaginationResponse.toJSON(message.pagination);
        }
        return obj;
    },
    create: function (base) {
        return exports.TransactionsResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseTransactionsResponse();
        message.transactions = ((_a = object.transactions) === null || _a === void 0 ? void 0 : _a.map(function (e) { return exports.Transaction.fromPartial(e); })) || [];
        message.pagination = (object.pagination !== undefined && object.pagination !== null)
            ? pagination_1.PaginationResponse.fromPartial(object.pagination)
            : undefined;
        return message;
    },
};
function createBaseTransaction() {
    return {
        payin_bank_wire: undefined,
        payin_card: undefined,
        payin_card_fail_transfer: undefined,
        payin_card_old: undefined,
        payin_direct_debit: undefined,
        payout_fail: undefined,
        payout_processing: undefined,
        payout_success: undefined,
        refund: undefined,
        repay_transfer_regular: undefined,
        sponsor_transfer: undefined,
        transfer_regular: undefined,
        transfer_regular_from_wallet: undefined,
        transfer_refund: undefined,
        kind: exports.TransactionKind.TRANSACTION_KIND_UNSPECIFIED,
    };
}
exports.Transaction = {
    fromJSON: function (object) {
        return {
            payin_bank_wire: isSet(object.payin_bank_wire) ? exports.TxBaseEvent.fromJSON(object.payin_bank_wire) : undefined,
            payin_card: isSet(object.payin_card) ? exports.TxBaseEvent.fromJSON(object.payin_card) : undefined,
            payin_card_fail_transfer: isSet(object.payin_card_fail_transfer)
                ? exports.TxBaseEvent.fromJSON(object.payin_card_fail_transfer)
                : undefined,
            payin_card_old: isSet(object.payin_card_old) ? exports.TxTransferEvent.fromJSON(object.payin_card_old) : undefined,
            payin_direct_debit: isSet(object.payin_direct_debit)
                ? exports.TxBaseEvent.fromJSON(object.payin_direct_debit)
                : undefined,
            payout_fail: isSet(object.payout_fail) ? exports.TxBaseEvent.fromJSON(object.payout_fail) : undefined,
            payout_processing: isSet(object.payout_processing) ? exports.TxBaseEvent.fromJSON(object.payout_processing) : undefined,
            payout_success: isSet(object.payout_success) ? exports.TxBaseEvent.fromJSON(object.payout_success) : undefined,
            refund: isSet(object.refund) ? exports.TxBaseEvent.fromJSON(object.refund) : undefined,
            repay_transfer_regular: isSet(object.repay_transfer_regular)
                ? exports.TxRepayTransferRegularEvent.fromJSON(object.repay_transfer_regular)
                : undefined,
            sponsor_transfer: isSet(object.sponsor_transfer)
                ? exports.TxSponsorTransferEvent.fromJSON(object.sponsor_transfer)
                : undefined,
            transfer_regular: isSet(object.transfer_regular) ? exports.TxTransferEvent.fromJSON(object.transfer_regular) : undefined,
            transfer_regular_from_wallet: isSet(object.transfer_regular_from_wallet)
                ? exports.TxTransferEvent.fromJSON(object.transfer_regular_from_wallet)
                : undefined,
            transfer_refund: isSet(object.transfer_refund)
                ? exports.TxTransferRefundEvent.fromJSON(object.transfer_refund)
                : undefined,
            kind: isSet(object.kind) ? transactionKindFromJSON(object.kind) : exports.TransactionKind.TRANSACTION_KIND_UNSPECIFIED,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.payin_bank_wire !== undefined) {
            obj.payin_bank_wire = exports.TxBaseEvent.toJSON(message.payin_bank_wire);
        }
        if (message.payin_card !== undefined) {
            obj.payin_card = exports.TxBaseEvent.toJSON(message.payin_card);
        }
        if (message.payin_card_fail_transfer !== undefined) {
            obj.payin_card_fail_transfer = exports.TxBaseEvent.toJSON(message.payin_card_fail_transfer);
        }
        if (message.payin_card_old !== undefined) {
            obj.payin_card_old = exports.TxTransferEvent.toJSON(message.payin_card_old);
        }
        if (message.payin_direct_debit !== undefined) {
            obj.payin_direct_debit = exports.TxBaseEvent.toJSON(message.payin_direct_debit);
        }
        if (message.payout_fail !== undefined) {
            obj.payout_fail = exports.TxBaseEvent.toJSON(message.payout_fail);
        }
        if (message.payout_processing !== undefined) {
            obj.payout_processing = exports.TxBaseEvent.toJSON(message.payout_processing);
        }
        if (message.payout_success !== undefined) {
            obj.payout_success = exports.TxBaseEvent.toJSON(message.payout_success);
        }
        if (message.refund !== undefined) {
            obj.refund = exports.TxBaseEvent.toJSON(message.refund);
        }
        if (message.repay_transfer_regular !== undefined) {
            obj.repay_transfer_regular = exports.TxRepayTransferRegularEvent.toJSON(message.repay_transfer_regular);
        }
        if (message.sponsor_transfer !== undefined) {
            obj.sponsor_transfer = exports.TxSponsorTransferEvent.toJSON(message.sponsor_transfer);
        }
        if (message.transfer_regular !== undefined) {
            obj.transfer_regular = exports.TxTransferEvent.toJSON(message.transfer_regular);
        }
        if (message.transfer_regular_from_wallet !== undefined) {
            obj.transfer_regular_from_wallet = exports.TxTransferEvent.toJSON(message.transfer_regular_from_wallet);
        }
        if (message.transfer_refund !== undefined) {
            obj.transfer_refund = exports.TxTransferRefundEvent.toJSON(message.transfer_refund);
        }
        if (message.kind !== exports.TransactionKind.TRANSACTION_KIND_UNSPECIFIED) {
            obj.kind = transactionKindToJSON(message.kind);
        }
        return obj;
    },
    create: function (base) {
        return exports.Transaction.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseTransaction();
        message.payin_bank_wire = (object.payin_bank_wire !== undefined && object.payin_bank_wire !== null)
            ? exports.TxBaseEvent.fromPartial(object.payin_bank_wire)
            : undefined;
        message.payin_card = (object.payin_card !== undefined && object.payin_card !== null)
            ? exports.TxBaseEvent.fromPartial(object.payin_card)
            : undefined;
        message.payin_card_fail_transfer =
            (object.payin_card_fail_transfer !== undefined && object.payin_card_fail_transfer !== null)
                ? exports.TxBaseEvent.fromPartial(object.payin_card_fail_transfer)
                : undefined;
        message.payin_card_old = (object.payin_card_old !== undefined && object.payin_card_old !== null)
            ? exports.TxTransferEvent.fromPartial(object.payin_card_old)
            : undefined;
        message.payin_direct_debit = (object.payin_direct_debit !== undefined && object.payin_direct_debit !== null)
            ? exports.TxBaseEvent.fromPartial(object.payin_direct_debit)
            : undefined;
        message.payout_fail = (object.payout_fail !== undefined && object.payout_fail !== null)
            ? exports.TxBaseEvent.fromPartial(object.payout_fail)
            : undefined;
        message.payout_processing = (object.payout_processing !== undefined && object.payout_processing !== null)
            ? exports.TxBaseEvent.fromPartial(object.payout_processing)
            : undefined;
        message.payout_success = (object.payout_success !== undefined && object.payout_success !== null)
            ? exports.TxBaseEvent.fromPartial(object.payout_success)
            : undefined;
        message.refund = (object.refund !== undefined && object.refund !== null)
            ? exports.TxBaseEvent.fromPartial(object.refund)
            : undefined;
        message.repay_transfer_regular =
            (object.repay_transfer_regular !== undefined && object.repay_transfer_regular !== null)
                ? exports.TxRepayTransferRegularEvent.fromPartial(object.repay_transfer_regular)
                : undefined;
        message.sponsor_transfer = (object.sponsor_transfer !== undefined && object.sponsor_transfer !== null)
            ? exports.TxSponsorTransferEvent.fromPartial(object.sponsor_transfer)
            : undefined;
        message.transfer_regular = (object.transfer_regular !== undefined && object.transfer_regular !== null)
            ? exports.TxTransferEvent.fromPartial(object.transfer_regular)
            : undefined;
        message.transfer_regular_from_wallet =
            (object.transfer_regular_from_wallet !== undefined && object.transfer_regular_from_wallet !== null)
                ? exports.TxTransferEvent.fromPartial(object.transfer_regular_from_wallet)
                : undefined;
        message.transfer_refund = (object.transfer_refund !== undefined && object.transfer_refund !== null)
            ? exports.TxTransferRefundEvent.fromPartial(object.transfer_refund)
            : undefined;
        message.kind = (_a = object.kind) !== null && _a !== void 0 ? _a : exports.TransactionKind.TRANSACTION_KIND_UNSPECIFIED;
        return message;
    },
};
function createBaseTxBaseEvent() {
    return { created_at: "", amount: 0 };
}
exports.TxBaseEvent = {
    fromJSON: function (object) {
        return {
            created_at: isSet(object.created_at) ? globalThis.String(object.created_at) : "",
            amount: isSet(object.amount) ? globalThis.Number(object.amount) : 0,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.created_at !== "") {
            obj.created_at = message.created_at;
        }
        if (message.amount !== 0) {
            obj.amount = Math.round(message.amount);
        }
        return obj;
    },
    create: function (base) {
        return exports.TxBaseEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseTxBaseEvent();
        message.created_at = (_a = object.created_at) !== null && _a !== void 0 ? _a : "";
        message.amount = (_b = object.amount) !== null && _b !== void 0 ? _b : 0;
        return message;
    },
};
function createBaseTxRepayTransferRegularEvent() {
    return { created_at: "", project_title: "", project_slug: "", tax_be: undefined, tax_fr: undefined, amount: 0 };
}
exports.TxRepayTransferRegularEvent = {
    fromJSON: function (object) {
        return {
            created_at: isSet(object.created_at) ? globalThis.String(object.created_at) : "",
            project_title: isSet(object.project_title) ? globalThis.String(object.project_title) : "",
            project_slug: isSet(object.project_slug) ? globalThis.String(object.project_slug) : "",
            tax_be: isSet(object.tax_be) ? exports.TxTax.fromJSON(object.tax_be) : undefined,
            tax_fr: isSet(object.tax_fr) ? exports.TxTax.fromJSON(object.tax_fr) : undefined,
            amount: isSet(object.amount) ? globalThis.Number(object.amount) : 0,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.created_at !== "") {
            obj.created_at = message.created_at;
        }
        if (message.project_title !== "") {
            obj.project_title = message.project_title;
        }
        if (message.project_slug !== "") {
            obj.project_slug = message.project_slug;
        }
        if (message.tax_be !== undefined) {
            obj.tax_be = exports.TxTax.toJSON(message.tax_be);
        }
        if (message.tax_fr !== undefined) {
            obj.tax_fr = exports.TxTax.toJSON(message.tax_fr);
        }
        if (message.amount !== 0) {
            obj.amount = Math.round(message.amount);
        }
        return obj;
    },
    create: function (base) {
        return exports.TxRepayTransferRegularEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d;
        var message = createBaseTxRepayTransferRegularEvent();
        message.created_at = (_a = object.created_at) !== null && _a !== void 0 ? _a : "";
        message.project_title = (_b = object.project_title) !== null && _b !== void 0 ? _b : "";
        message.project_slug = (_c = object.project_slug) !== null && _c !== void 0 ? _c : "";
        message.tax_be = (object.tax_be !== undefined && object.tax_be !== null)
            ? exports.TxTax.fromPartial(object.tax_be)
            : undefined;
        message.tax_fr = (object.tax_fr !== undefined && object.tax_fr !== null)
            ? exports.TxTax.fromPartial(object.tax_fr)
            : undefined;
        message.amount = (_d = object.amount) !== null && _d !== void 0 ? _d : 0;
        return message;
    },
};
function createBaseTxSponsorTransferEvent() {
    return {
        created_at: "",
        project_title: "",
        project_slug: "",
        project_user_full_name: undefined,
        partner_name: "",
        collect_type: collect_1.CollectType.COLLECT_TYPE_UNSPECIFIED,
        amount: 0,
    };
}
exports.TxSponsorTransferEvent = {
    fromJSON: function (object) {
        return {
            created_at: isSet(object.created_at) ? globalThis.String(object.created_at) : "",
            project_title: isSet(object.project_title) ? globalThis.String(object.project_title) : "",
            project_slug: isSet(object.project_slug) ? globalThis.String(object.project_slug) : "",
            project_user_full_name: isSet(object.project_user_full_name)
                ? globalThis.String(object.project_user_full_name)
                : undefined,
            partner_name: isSet(object.partner_name) ? globalThis.String(object.partner_name) : "",
            collect_type: isSet(object.collect_type)
                ? (0, collect_1.collectTypeFromJSON)(object.collect_type)
                : collect_1.CollectType.COLLECT_TYPE_UNSPECIFIED,
            amount: isSet(object.amount) ? globalThis.Number(object.amount) : 0,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.created_at !== "") {
            obj.created_at = message.created_at;
        }
        if (message.project_title !== "") {
            obj.project_title = message.project_title;
        }
        if (message.project_slug !== "") {
            obj.project_slug = message.project_slug;
        }
        if (message.project_user_full_name !== undefined) {
            obj.project_user_full_name = message.project_user_full_name;
        }
        if (message.partner_name !== "") {
            obj.partner_name = message.partner_name;
        }
        if (message.collect_type !== collect_1.CollectType.COLLECT_TYPE_UNSPECIFIED) {
            obj.collect_type = (0, collect_1.collectTypeToJSON)(message.collect_type);
        }
        if (message.amount !== 0) {
            obj.amount = Math.round(message.amount);
        }
        return obj;
    },
    create: function (base) {
        return exports.TxSponsorTransferEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d, _e, _f, _g;
        var message = createBaseTxSponsorTransferEvent();
        message.created_at = (_a = object.created_at) !== null && _a !== void 0 ? _a : "";
        message.project_title = (_b = object.project_title) !== null && _b !== void 0 ? _b : "";
        message.project_slug = (_c = object.project_slug) !== null && _c !== void 0 ? _c : "";
        message.project_user_full_name = (_d = object.project_user_full_name) !== null && _d !== void 0 ? _d : undefined;
        message.partner_name = (_e = object.partner_name) !== null && _e !== void 0 ? _e : "";
        message.collect_type = (_f = object.collect_type) !== null && _f !== void 0 ? _f : collect_1.CollectType.COLLECT_TYPE_UNSPECIFIED;
        message.amount = (_g = object.amount) !== null && _g !== void 0 ? _g : 0;
        return message;
    },
};
function createBaseTxTransferEvent() {
    return {
        created_at: "",
        project_title: "",
        project_slug: "",
        project_user_full_name: undefined,
        reward_title: undefined,
        voucher: undefined,
        collect_type: collect_1.CollectType.COLLECT_TYPE_UNSPECIFIED,
        amount: 0,
    };
}
exports.TxTransferEvent = {
    fromJSON: function (object) {
        return {
            created_at: isSet(object.created_at) ? globalThis.String(object.created_at) : "",
            project_title: isSet(object.project_title) ? globalThis.String(object.project_title) : "",
            project_slug: isSet(object.project_slug) ? globalThis.String(object.project_slug) : "",
            project_user_full_name: isSet(object.project_user_full_name)
                ? globalThis.String(object.project_user_full_name)
                : undefined,
            reward_title: isSet(object.reward_title) ? globalThis.String(object.reward_title) : undefined,
            voucher: isSet(object.voucher) ? exports.TxVoucher.fromJSON(object.voucher) : undefined,
            collect_type: isSet(object.collect_type)
                ? (0, collect_1.collectTypeFromJSON)(object.collect_type)
                : collect_1.CollectType.COLLECT_TYPE_UNSPECIFIED,
            amount: isSet(object.amount) ? globalThis.Number(object.amount) : 0,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.created_at !== "") {
            obj.created_at = message.created_at;
        }
        if (message.project_title !== "") {
            obj.project_title = message.project_title;
        }
        if (message.project_slug !== "") {
            obj.project_slug = message.project_slug;
        }
        if (message.project_user_full_name !== undefined) {
            obj.project_user_full_name = message.project_user_full_name;
        }
        if (message.reward_title !== undefined) {
            obj.reward_title = message.reward_title;
        }
        if (message.voucher !== undefined) {
            obj.voucher = exports.TxVoucher.toJSON(message.voucher);
        }
        if (message.collect_type !== collect_1.CollectType.COLLECT_TYPE_UNSPECIFIED) {
            obj.collect_type = (0, collect_1.collectTypeToJSON)(message.collect_type);
        }
        if (message.amount !== 0) {
            obj.amount = Math.round(message.amount);
        }
        return obj;
    },
    create: function (base) {
        return exports.TxTransferEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d, _e, _f, _g;
        var message = createBaseTxTransferEvent();
        message.created_at = (_a = object.created_at) !== null && _a !== void 0 ? _a : "";
        message.project_title = (_b = object.project_title) !== null && _b !== void 0 ? _b : "";
        message.project_slug = (_c = object.project_slug) !== null && _c !== void 0 ? _c : "";
        message.project_user_full_name = (_d = object.project_user_full_name) !== null && _d !== void 0 ? _d : undefined;
        message.reward_title = (_e = object.reward_title) !== null && _e !== void 0 ? _e : undefined;
        message.voucher = (object.voucher !== undefined && object.voucher !== null)
            ? exports.TxVoucher.fromPartial(object.voucher)
            : undefined;
        message.collect_type = (_f = object.collect_type) !== null && _f !== void 0 ? _f : collect_1.CollectType.COLLECT_TYPE_UNSPECIFIED;
        message.amount = (_g = object.amount) !== null && _g !== void 0 ? _g : 0;
        return message;
    },
};
function createBaseTxTransferRefundEvent() {
    return {
        created_at: "",
        reason: "",
        project_title: undefined,
        project_slug: undefined,
        project_user_full_name: undefined,
        amount: 0,
    };
}
exports.TxTransferRefundEvent = {
    fromJSON: function (object) {
        return {
            created_at: isSet(object.created_at) ? globalThis.String(object.created_at) : "",
            reason: isSet(object.reason) ? globalThis.String(object.reason) : "",
            project_title: isSet(object.project_title) ? globalThis.String(object.project_title) : undefined,
            project_slug: isSet(object.project_slug) ? globalThis.String(object.project_slug) : undefined,
            project_user_full_name: isSet(object.project_user_full_name)
                ? globalThis.String(object.project_user_full_name)
                : undefined,
            amount: isSet(object.amount) ? globalThis.Number(object.amount) : 0,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.created_at !== "") {
            obj.created_at = message.created_at;
        }
        if (message.reason !== "") {
            obj.reason = message.reason;
        }
        if (message.project_title !== undefined) {
            obj.project_title = message.project_title;
        }
        if (message.project_slug !== undefined) {
            obj.project_slug = message.project_slug;
        }
        if (message.project_user_full_name !== undefined) {
            obj.project_user_full_name = message.project_user_full_name;
        }
        if (message.amount !== 0) {
            obj.amount = Math.round(message.amount);
        }
        return obj;
    },
    create: function (base) {
        return exports.TxTransferRefundEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d, _e, _f;
        var message = createBaseTxTransferRefundEvent();
        message.created_at = (_a = object.created_at) !== null && _a !== void 0 ? _a : "";
        message.reason = (_b = object.reason) !== null && _b !== void 0 ? _b : "";
        message.project_title = (_c = object.project_title) !== null && _c !== void 0 ? _c : undefined;
        message.project_slug = (_d = object.project_slug) !== null && _d !== void 0 ? _d : undefined;
        message.project_user_full_name = (_e = object.project_user_full_name) !== null && _e !== void 0 ? _e : undefined;
        message.amount = (_f = object.amount) !== null && _f !== void 0 ? _f : 0;
        return message;
    },
};
function createBaseTxTax() {
    return { amount: 0, rate: 0 };
}
exports.TxTax = {
    fromJSON: function (object) {
        return {
            amount: isSet(object.amount) ? globalThis.Number(object.amount) : 0,
            rate: isSet(object.rate) ? globalThis.Number(object.rate) : 0,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.amount !== 0) {
            obj.amount = Math.round(message.amount);
        }
        if (message.rate !== 0) {
            obj.rate = message.rate;
        }
        return obj;
    },
    create: function (base) {
        return exports.TxTax.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseTxTax();
        message.amount = (_a = object.amount) !== null && _a !== void 0 ? _a : 0;
        message.rate = (_b = object.rate) !== null && _b !== void 0 ? _b : 0;
        return message;
    },
};
function createBaseTxVoucher() {
    return { amount: 0, code: "" };
}
exports.TxVoucher = {
    fromJSON: function (object) {
        return {
            amount: isSet(object.amount) ? globalThis.Number(object.amount) : 0,
            code: isSet(object.code) ? globalThis.String(object.code) : "",
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.amount !== 0) {
            obj.amount = Math.round(message.amount);
        }
        if (message.code !== "") {
            obj.code = message.code;
        }
        return obj;
    },
    create: function (base) {
        return exports.TxVoucher.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseTxVoucher();
        message.amount = (_a = object.amount) !== null && _a !== void 0 ? _a : 0;
        message.code = (_b = object.code) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseTransactionsExportRequest() {
    return { req_as_user: undefined };
}
exports.TransactionsExportRequest = {
    fromJSON: function (object) {
        return { req_as_user: isSet(object.req_as_user) ? exports.RequestAsUser.fromJSON(object.req_as_user) : undefined };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.req_as_user !== undefined) {
            obj.req_as_user = exports.RequestAsUser.toJSON(message.req_as_user);
        }
        return obj;
    },
    create: function (base) {
        return exports.TransactionsExportRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var message = createBaseTransactionsExportRequest();
        message.req_as_user = (object.req_as_user !== undefined && object.req_as_user !== null)
            ? exports.RequestAsUser.fromPartial(object.req_as_user)
            : undefined;
        return message;
    },
};
function createBaseTransactionsExportResponse() {
    return {};
}
exports.TransactionsExportResponse = {
    fromJSON: function (_) {
        return {};
    },
    toJSON: function (_) {
        var obj = {};
        return obj;
    },
    create: function (base) {
        return exports.TransactionsExportResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (_) {
        var message = createBaseTransactionsExportResponse();
        return message;
    },
};
function createBaseRepayTermsExportRequest() {
    return { req_as_user: undefined };
}
exports.RepayTermsExportRequest = {
    fromJSON: function (object) {
        return { req_as_user: isSet(object.req_as_user) ? exports.RequestAsUser.fromJSON(object.req_as_user) : undefined };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.req_as_user !== undefined) {
            obj.req_as_user = exports.RequestAsUser.toJSON(message.req_as_user);
        }
        return obj;
    },
    create: function (base) {
        return exports.RepayTermsExportRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var message = createBaseRepayTermsExportRequest();
        message.req_as_user = (object.req_as_user !== undefined && object.req_as_user !== null)
            ? exports.RequestAsUser.fromPartial(object.req_as_user)
            : undefined;
        return message;
    },
};
function createBaseRepayTermsExportResponse() {
    return {};
}
exports.RepayTermsExportResponse = {
    fromJSON: function (_) {
        return {};
    },
    toJSON: function (_) {
        var obj = {};
        return obj;
    },
    create: function (base) {
        return exports.RepayTermsExportResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (_) {
        var message = createBaseRepayTermsExportResponse();
        return message;
    },
};
function createBaseRefreshLenderLoanSummariesEvent() {
    return { user_id: undefined };
}
exports.RefreshLenderLoanSummariesEvent = {
    fromJSON: function (object) {
        return { user_id: isSet(object.user_id) ? globalThis.Number(object.user_id) : undefined };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.user_id !== undefined) {
            obj.user_id = Math.round(message.user_id);
        }
        return obj;
    },
    create: function (base) {
        return exports.RefreshLenderLoanSummariesEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseRefreshLenderLoanSummariesEvent();
        message.user_id = (_a = object.user_id) !== null && _a !== void 0 ? _a : undefined;
        return message;
    },
};
function createBaseRefreshRecoverySummaryEvent() {
    return { account_id: 0 };
}
exports.RefreshRecoverySummaryEvent = {
    fromJSON: function (object) {
        return { account_id: isSet(object.account_id) ? globalThis.Number(object.account_id) : 0 };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.account_id !== 0) {
            obj.account_id = Math.round(message.account_id);
        }
        return obj;
    },
    create: function (base) {
        return exports.RefreshRecoverySummaryEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseRefreshRecoverySummaryEvent();
        message.account_id = (_a = object.account_id) !== null && _a !== void 0 ? _a : 0;
        return message;
    },
};
function createBaseTransactionsExportEvent() {
    return { user_id: 0, email_to_user_id: undefined };
}
exports.TransactionsExportEvent = {
    fromJSON: function (object) {
        return {
            user_id: isSet(object.user_id) ? globalThis.Number(object.user_id) : 0,
            email_to_user_id: isSet(object.email_to_user_id) ? globalThis.Number(object.email_to_user_id) : undefined,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.user_id !== 0) {
            obj.user_id = Math.round(message.user_id);
        }
        if (message.email_to_user_id !== undefined) {
            obj.email_to_user_id = Math.round(message.email_to_user_id);
        }
        return obj;
    },
    create: function (base) {
        return exports.TransactionsExportEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseTransactionsExportEvent();
        message.user_id = (_a = object.user_id) !== null && _a !== void 0 ? _a : 0;
        message.email_to_user_id = (_b = object.email_to_user_id) !== null && _b !== void 0 ? _b : undefined;
        return message;
    },
};
function createBaseRepayTermsExportEvent() {
    return { user_id: 0, email_to_user_id: undefined };
}
exports.RepayTermsExportEvent = {
    fromJSON: function (object) {
        return {
            user_id: isSet(object.user_id) ? globalThis.Number(object.user_id) : 0,
            email_to_user_id: isSet(object.email_to_user_id) ? globalThis.Number(object.email_to_user_id) : undefined,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.user_id !== 0) {
            obj.user_id = Math.round(message.user_id);
        }
        if (message.email_to_user_id !== undefined) {
            obj.email_to_user_id = Math.round(message.email_to_user_id);
        }
        return obj;
    },
    create: function (base) {
        return exports.RepayTermsExportEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseRepayTermsExportEvent();
        message.user_id = (_a = object.user_id) !== null && _a !== void 0 ? _a : 0;
        message.email_to_user_id = (_b = object.email_to_user_id) !== null && _b !== void 0 ? _b : undefined;
        return message;
    },
};
function bytesFromBase64(b64) {
    if (globalThis.Buffer) {
        return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
    }
    else {
        var bin = globalThis.atob(b64);
        var arr = new Uint8Array(bin.length);
        for (var i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(arr).toString("base64");
    }
    else {
        var bin_1 = [];
        arr.forEach(function (byte) {
            bin_1.push(globalThis.String.fromCharCode(byte));
        });
        return globalThis.btoa(bin_1.join(""));
    }
}
function isObject(value) {
    return typeof value === "object" && value !== null;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
function handleRequest(url, requestBody, fromJSON, options) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var response, responseBody, parseError_1, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 7, , 8]);
                    if (options === null || options === void 0 ? void 0 : options.debug) {
                        console.log('[CLIENT DEBUG] request:\n', JSON.stringify(requestBody));
                    }
                    return [4 /*yield*/, fetch(url, {
                            method: 'POST',
                            body: JSON.stringify(requestBody),
                            headers: __assign(__assign({ 'Content-Type': 'application/json' }, ((_a = options === null || options === void 0 ? void 0 : options.headers) !== null && _a !== void 0 ? _a : {})), ((options === null || options === void 0 ? void 0 : options.user_id) ? { 'X-Jwt-Payload-B64': options.user_id } : {}))
                        })];
                case 1:
                    response = _b.sent();
                    if (options === null || options === void 0 ? void 0 : options.debug) {
                        console.log('[CLIENT DEBUG] response:\n', JSON.stringify(response));
                    }
                    responseBody = void 0;
                    _b.label = 2;
                case 2:
                    _b.trys.push([2, 4, , 6]);
                    return [4 /*yield*/, response.json()];
                case 3:
                    responseBody = _b.sent();
                    return [3 /*break*/, 6];
                case 4:
                    parseError_1 = _b.sent();
                    return [4 /*yield*/, response.text()];
                case 5:
                    responseBody = _b.sent();
                    return [3 /*break*/, 6];
                case 6:
                    if (!response.ok) {
                        throw {
                            statusText: response.statusText || 'HTTP Error',
                            body: responseBody
                        };
                    }
                    return [2 /*return*/, fromJSON(responseBody)];
                case 7:
                    error_1 = _b.sent();
                    if (options === null || options === void 0 ? void 0 : options.debug) {
                        console.error('[CLIENT DEBUG] error:\n', JSON.stringify(error_1));
                    }
                    if (error_1.statusText) {
                        // This is our custom error object from above
                        throw error_1;
                    }
                    else {
                        // This could be a network error or other fetch-related error
                        throw {
                            statusText: 'Network Error',
                            body: error_1.message || 'An unknown error occurred',
                            error: error_1,
                        };
                    }
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    });
}
var DashboardServiceClient = /** @class */ (function () {
    function DashboardServiceClient(fetcher, baseURL) {
        this.fetcher = fetcher;
        this.baseURL = baseURL;
    }
    DashboardServiceClient.prototype.Health = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = health_1.HealthRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.loans.v1.DashboardService/Health";
                return [2 /*return*/, handleRequest(url, jsonReq, health_1.HealthResponse.fromJSON, options)];
            });
        });
    };
    DashboardServiceClient.prototype.LenderLoanSummaries = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.LenderLoanSummariesRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.loans.v1.DashboardService/LenderLoanSummaries";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.LenderLoanSummariesResponse.fromJSON, options)];
            });
        });
    };
    DashboardServiceClient.prototype.RepayTermSummaries = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.RepayTermSummariesRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.loans.v1.DashboardService/RepayTermSummaries";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.RepayTermSummariesResponse.fromJSON, options)];
            });
        });
    };
    DashboardServiceClient.prototype.AvailableRepayTermYears = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.AvailableRepayTermYearsRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.loans.v1.DashboardService/AvailableRepayTermYears";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.AvailableRepayTermYearsResponse.fromJSON, options)];
            });
        });
    };
    DashboardServiceClient.prototype.LenderLoanSummary = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.LenderLoanSummaryRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.loans.v1.DashboardService/LenderLoanSummary";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.LenderLoanSummaryResponse.fromJSON, options)];
            });
        });
    };
    DashboardServiceClient.prototype.ExtractLenderLoanSummariesXLS = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.ExtractLenderLoanSummariesXLSRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.loans.v1.DashboardService/ExtractLenderLoanSummariesXLS";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.ExtractLenderLoanSummariesXLSResponse.fromJSON, options)];
            });
        });
    };
    DashboardServiceClient.prototype.LenderPortfolioSummary = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.LenderPortfolioSummaryRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.loans.v1.DashboardService/LenderPortfolioSummary";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.LenderPortfolioSummaryResponse.fromJSON, options)];
            });
        });
    };
    DashboardServiceClient.prototype.FinancialStatement = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.FinancialStatementRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.loans.v1.DashboardService/FinancialStatement";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.FinancialStatementResponse.fromJSON, options)];
            });
        });
    };
    DashboardServiceClient.prototype.LendingNotes = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.LendingNotesRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.loans.v1.DashboardService/LendingNotes";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.LendingNotesResponse.fromJSON, options)];
            });
        });
    };
    DashboardServiceClient.prototype.Transactions = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.TransactionsRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.loans.v1.DashboardService/Transactions";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.TransactionsResponse.fromJSON, options)];
            });
        });
    };
    DashboardServiceClient.prototype.TransactionsExport = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.TransactionsExportRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.loans.v1.DashboardService/TransactionsExport";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.TransactionsExportResponse.fromJSON, options)];
            });
        });
    };
    DashboardServiceClient.prototype.RepayTermsExport = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.RepayTermsExportRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.loans.v1.DashboardService/RepayTermsExport";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.RepayTermsExportResponse.fromJSON, options)];
            });
        });
    };
    return DashboardServiceClient;
}());
exports.DashboardServiceClient = DashboardServiceClient;
//# sourceMappingURL=dashboard.js.map